{
	"nm": "Gif",
	"ddd": 0,
	"h": 244,
	"w": 668,
	"meta": { "g": "LottieFiles Figma v124" },
	"layers": [
		{
			"ty": 4,
			"nm": "Loom",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Loom 1",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [200, 90] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [334, 122] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [],
			"ind": 1
		},
		{
			"ty": 0,
			"nm": "Gestural Line/scribble 3",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Gestural Line/scribble 3 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [19.39, 20.14] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [70.6, 67.91] },
				"r": { "a": 0, "k": 28.13 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{
							"h": 1,
							"o": { "x": 0.167, "y": 0.167 },
							"i": { "x": 0.833, "y": 0.833 },
							"s": [0],
							"t": 0
						},
						{
							"h": 1,
							"o": { "x": 0.167, "y": 0.167 },
							"i": { "x": 0.833, "y": 0.833 },
							"s": [0],
							"t": 222
						},
						{ "s": [100], "t": 240 }
					]
				}
			},
			"ef": [],
			"w": 668,
			"h": 244,
			"refId": "1",
			"ind": 2,
			"parent": 1
		},
		{
			"ty": 0,
			"nm": "Gestural Line/scribble 4",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Gestural Line/scribble 4 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [60.21, 30.74] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [282.26, 144.42] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 0 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 168 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 186 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 222 },
						{ "s": [0], "t": 240 }
					]
				}
			},
			"ef": [],
			"w": 668,
			"h": 244,
			"refId": "3",
			"ind": 3,
			"parent": 1
		},
		{
			"ty": 0,
			"nm": "Gestural Line/scribble 2",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Gestural Line/scribble 2 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [42.99, 15.56] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [173.25, 55.99] },
				"r": { "a": 0, "k": 28.13 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 0 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 114 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 132 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 168 },
						{ "s": [0], "t": 222 }
					]
				}
			},
			"ef": [],
			"w": 668,
			"h": 244,
			"refId": "5",
			"ind": 4,
			"parent": 1
		},
		{
			"ty": 0,
			"nm": "Gestural Line/scribble 1",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Gestural Line/scribble 1 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [87.36, 20.24] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [116.46, 149.84] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 0 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 60 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 78 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 114 },
						{ "s": [0], "t": 168 }
					]
				}
			},
			"ef": [],
			"w": 668,
			"h": 244,
			"refId": "7",
			"ind": 5,
			"parent": 1
		},
		{
			"ty": 0,
			"nm": "Gestural Line/symbol check 2",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Gestural Line/symbol check 2 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [23.88, 23] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [337.77, 66] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": {
					"a": 1,
					"k": [
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 0 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 6 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 24 },
						{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 60 },
						{ "s": [0], "t": 114 }
					]
				}
			},
			"ef": [],
			"w": 668,
			"h": 244,
			"refId": "9",
			"ind": 6,
			"parent": 1
		},
		{
			"ty": 4,
			"nm": "Loom Bg",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Loom 1-bg",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [200, 90] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [200, 90] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, -0.01],
								[0, 0],
								[0.01, 0],
								[0, 0],
								[0, 0.01],
								[0, 0],
								[-0.01, 0],
								[0, 0]
							],
							"o": [
								[0, 0],
								[0, 0.01],
								[0, 0],
								[-0.01, 0],
								[0, 0],
								[0, -0.01],
								[0, 0],
								[0.01, 0]
							],
							"v": [
								[400, 0.01],
								[400, 179.99],
								[399.99, 180],
								[0.01, 180],
								[0, 179.99],
								[0, 0.01],
								[0.01, 0],
								[399.99, 0]
							]
						}
					}
				}
			],
			"ind": 7,
			"parent": 1
		},
		{
			"ty": 4,
			"nm": "Logo",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Logo 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [27, 27] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [334, 122] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [],
			"ind": 8
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 10",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [27, 27] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [27, 27] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"o": [
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0],
								[0, 0]
							],
							"v": [
								[54, 24],
								[38.21, 24],
								[51.89, 16.1],
								[48.88, 10.9],
								[35.21, 18.79],
								[43.1, 5.12],
								[37.9, 2.12],
								[30, 15.79],
								[30, 0],
								[24, 0],
								[24, 15.79],
								[16.1, 2.12],
								[10.9, 5.12],
								[18.79, 18.79],
								[5.12, 10.9],
								[2.12, 16.1],
								[15.79, 24],
								[0, 24],
								[0, 30],
								[15.79, 30],
								[2.12, 37.9],
								[5.12, 43.1],
								[18.79, 35.21],
								[10.9, 48.88],
								[16.1, 51.88],
								[24, 38.21],
								[24, 54],
								[30, 54],
								[30, 38.21],
								[37.9, 51.88],
								[43.1, 48.88],
								[35.2, 35.21],
								[48.88, 43.1],
								[51.88, 37.9],
								[38.21, 30],
								[54, 30],
								[54, 24],
								[54, 24]
							]
						}
					}
				},
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0, 4.53],
								[-4.53, 0],
								[0, -4.53],
								[4.53, 0]
							],
							"o": [
								[-4.53, 0],
								[0, -4.53],
								[4.53, 0],
								[0, 4.53],
								[0, 0]
							],
							"v": [
								[27, 35.17],
								[18.8, 26.97],
								[27, 18.77],
								[35.2, 26.97],
								[27, 35.17]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [1, 1, 1] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 9,
			"parent": 8
		},
		{
			"ty": 0,
			"nm": "Loom",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Loom 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": true,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [46, 46] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [334, 122] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"masksProperties": [
				{
					"nm": "",
					"inv": false,
					"mode": "a",
					"x": { "a": 0, "k": 0 },
					"o": { "a": 0, "k": 100 },
					"pt": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, -8.97],
								[0, 0],
								[8.97, 0],
								[0, 0],
								[0, 8.97],
								[0, 0],
								[-8.97, 0],
								[0, 0]
							],
							"o": [
								[0, 0],
								[0, 8.97],
								[0, 0],
								[-8.97, 0],
								[0, 0],
								[0, -8.97],
								[0, 0],
								[8.97, 0]
							],
							"v": [
								[92, 16.25],
								[92, 75.75],
								[75.75, 92],
								[16.25, 92],
								[0, 75.75],
								[0, 16.25],
								[16.25, 0],
								[75.75, 0]
							]
						}
					}
				}
			],
			"w": 668,
			"h": 244,
			"refId": "10",
			"ind": 10
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 8",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [8.12, 2.56] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [597.3, 28.51] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[-0.41, -0.24],
								[-0.79, 0],
								[-0.61, -0.04],
								[-0.42, -0.16],
								[-0.06, 0.01],
								[-1.68, -0.13],
								[-0.38, 0.01],
								[-0.65, 0.47],
								[0.37, 0.24],
								[0.9, -0.01],
								[1.03, 0.07],
								[0.16, -0.09],
								[0, 0],
								[1.17, -0.03],
								[0.26, -0.01],
								[0.58, -0.37],
								[0, 0]
							],
							"o": [
								[-0.41, 0.26],
								[0.59, 0.34],
								[0.89, -0.14],
								[1.03, -0.03],
								[0.06, 0.02],
								[0.44, -0.1],
								[1.18, -0.04],
								[0.9, -0.04],
								[0.36, -0.26],
								[-0.67, -0.44],
								[-0.35, 0.01],
								[-0.17, -0.01],
								[-1.42, 0.81],
								[0, 0],
								[-0.89, 0.03],
								[-0.79, 0.04],
								[0, 0],
								[0, 0]
							],
							"v": [
								[0.27, 1.55],
								[0.35, 4.44],
								[2.36, 4.95],
								[4.07, 4.35],
								[7.26, 5.09],
								[7.45, 5.11],
								[11.49, 4.71],
								[13.78, 4.63],
								[16, 3.86],
								[15.93, 1.27],
								[13.67, 0.62],
								[11.55, 0],
								[11.05, 0.13],
								[7.77, 0.78],
								[3.82, 0.88],
								[2.24, 0.94],
								[0.26, 1.55],
								[0.27, 1.55]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 11
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 7",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [2.87, 10.17] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [598.63, 28.03] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0.2, -0.54],
								[-0.07, -0.99],
								[-0.01, -0.76],
								[0.11, -0.54],
								[-0.01, -0.08],
								[-0.01, -2.1],
								[-0.05, -0.47],
								[-0.53, -0.79],
								[-0.21, 0.48],
								[0.09, 1.12],
								[0.01, 1.29],
								[0.11, 0.2],
								[0, 0],
								[0.13, 1.47],
								[0.03, 0.32],
								[0.41, 0.7],
								[0, 0]
							],
							"o": [
								[-0.29, -0.49],
								[-0.29, 0.76],
								[0.21, 1.11],
								[0.11, 1.28],
								[-0.01, 0.08],
								[0.14, 0.54],
								[0.14, 1.47],
								[0.12, 1.12],
								[0.29, 0.43],
								[0.38, -0.86],
								[-0.04, -0.44],
								[0, -0.21],
								[-0.94, -1.72],
								[0, 0],
								[-0.11, -1.1],
								[-0.11, -0.99],
								[0, 0],
								[0, 0]
							],
							"v": [
								[3.24, 0.28],
								[0.36, 0.53],
								[0.02, 3.07],
								[0.76, 5.18],
								[0.29, 9.23],
								[0.29, 9.46],
								[1.02, 14.5],
								[1.29, 17.36],
								[2.26, 20.09],
								[4.83, 19.86],
								[5.3, 17.01],
								[5.73, 14.32],
								[5.56, 13.7],
								[4.64, 9.63],
								[4.21, 4.69],
								[4.02, 2.73],
								[3.24, 0.29],
								[3.24, 0.28]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 12
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 6",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [8.12, 2.43] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [636.96, 63.33] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[-0.39, -0.28],
								[-0.79, -0.07],
								[-0.6, -0.1],
								[-0.4, -0.2],
								[-0.06, 0.01],
								[-1.66, -0.29],
								[-0.38, -0.02],
								[-0.69, 0.41],
								[0.34, 0.27],
								[0.9, 0.09],
								[1.02, 0.17],
								[0.17, -0.08],
								[0, 0],
								[1.17, 0.09],
								[0.26, 0.01],
								[0.61, -0.31],
								[0, 0]
							],
							"o": [
								[-0.43, 0.22],
								[0.56, 0.39],
								[0.9, -0.05],
								[1.02, 0.07],
								[0.06, 0.03],
								[0.45, -0.06],
								[1.18, 0.08],
								[0.9, 0.05],
								[0.38, -0.22],
								[-0.63, -0.5],
								[-0.35, -0.03],
								[-0.16, -0.03],
								[-1.49, 0.67],
								[0, 0],
								[-0.89, -0.06],
								[-0.79, -0.04],
								[0, 0],
								[0, 0]
							],
							"v": [
								[0.43, 0.44],
								[0.22, 3.33],
								[2.17, 4.03],
								[3.94, 3.6],
								[7.05, 4.66],
								[7.23, 4.69],
								[11.3, 4.69],
								[13.59, 4.84],
								[15.87, 4.29],
								[16.05, 1.71],
								[13.87, 0.83],
								[11.81, 0.01],
								[11.31, 0.09],
								[7.98, 0.41],
								[4.03, 0.12],
								[2.47, 0.02],
								[0.43, 0.43],
								[0.43, 0.44]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 13
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 5",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [2.73, 7.69] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [637.34, 64.32] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0.21, -0.41],
								[-0.05, -0.75],
								[0.01, -0.57],
								[0.13, -0.41],
								[-0.02, -0.06],
								[0.04, -1.59],
								[-0.03, -0.36],
								[-0.51, -0.58],
								[-0.22, 0.36],
								[0.06, 0.85],
								[-0.01, 0.98],
								[0.11, 0.15],
								[0, 0],
								[0.09, 1.11],
								[0.03, 0.24],
								[0.4, 0.52],
								[0, 0]
							],
							"o": [
								[-0.29, -0.37],
								[-0.31, 0.59],
								[0.19, 0.84],
								[0.09, 0.97],
								[-0.02, 0.06],
								[0.13, 0.41],
								[0.11, 1.12],
								[0.09, 0.85],
								[0.28, 0.32],
								[0.4, -0.66],
								[-0.03, -0.33],
								[0, -0.16],
								[-0.89, -1.29],
								[0, 0],
								[-0.08, -0.84],
								[-0.08, -0.74],
								[0, 0],
								[0, 0]
							],
							"v": [
								[3.28, 0.19],
								[0.4, 0.44],
								[0.01, 2.37],
								[0.7, 3.95],
								[0.14, 7.03],
								[0.14, 7.2],
								[0.75, 11.01],
								[0.95, 13.17],
								[1.85, 15.21],
								[4.43, 14.99],
								[4.96, 12.82],
								[5.46, 10.76],
								[5.3, 10.3],
								[4.47, 7.23],
								[4.16, 3.5],
								[4.01, 2.02],
								[3.29, 0.19],
								[3.28, 0.19]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 14
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 4",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [9.26, 2.84] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [678.59, 46.89] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[-0.49, -0.14],
								[-0.86, 0.14],
								[-0.67, 0.04],
								[-0.46, -0.13],
								[-0.07, 0.02],
								[-1.84, -0.16],
								[-0.41, -0.01],
								[-0.76, 0.39],
								[0.41, 0.29],
								[1.07, 0.05],
								[1.23, 0.09],
								[0.19, -0.1],
								[0.75, -0.09],
								[0, 0],
								[0.98, -0.1],
								[0.69, -0.09],
								[0.31, -0.06],
								[0.6, -0.51],
								[0, 0]
							],
							"o": [
								[-0.42, 0.35],
								[0.7, 0.2],
								[0.94, -0.29],
								[1.14, -0.18],
								[0.07, 0.02],
								[0.47, -0.14],
								[1.3, -0.01],
								[0.99, 0.01],
								[0.41, -0.21],
								[-0.73, -0.52],
								[-0.41, -0.02],
								[-0.2, -0.01],
								[-0.84, 0.41],
								[-0.75, 0.09],
								[0, 0],
								[-0.99, 0.09],
								[-1.03, 0.16],
								[-0.92, 0.18],
								[0, 0],
								[0, 0]
							],
							"v": [
								[0.14, 2.68],
								[0.8, 5.49],
								[3.05, 5.61],
								[4.84, 4.76],
								[8.42, 5.2],
								[8.63, 5.2],
								[13.08, 4.71],
								[15.59, 4.72],
								[18.07, 4.16],
								[18.32, 1.59],
								[15.73, 0.71],
								[13.23, 0],
								[12.64, 0.12],
								[10.09, 0.79],
								[8.79, 0.86],
								[6.99, 1.01],
								[4.17, 1.34],
								[2.34, 1.65],
								[0.14, 2.67],
								[0.14, 2.68]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 15
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 3",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [2.61, 11.28] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [679.28, 47.19] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0.22, -0.59],
								[-0.03, -1.1],
								[0.03, -0.85],
								[0.14, -0.59],
								[-0.01, -0.09],
								[0.08, -2.33],
								[-0.02, -0.53],
								[-0.49, -0.9],
								[-0.23, 0.51],
								[0.04, 1.25],
								[-0.04, 1.43],
								[0.1, 0.23],
								[0, 0],
								[0.06, 1.63],
								[0.01, 0.36],
								[0.39, 0.8],
								[0, 0]
							],
							"o": [
								[-0.27, -0.56],
								[-0.32, 0.83],
								[0.16, 1.24],
								[0.06, 1.42],
								[-0.02, 0.09],
								[0.11, 0.61],
								[0.07, 1.64],
								[0.06, 1.25],
								[0.27, 0.49],
								[0.42, -0.94],
								[-0.01, -0.49],
								[0, -0.24],
								[-0.86, -1.97],
								[0, 0],
								[-0.06, -1.23],
								[-0.06, -1.1],
								[0, 0],
								[0, 0]
							],
							"v": [
								[3.37, 0.38],
								[0.48, 0.49],
								[0.03, 3.28],
								[0.67, 5.66],
								[0.02, 10.11],
								[0.01, 10.36],
								[0.51, 15.98],
								[0.65, 19.16],
								[1.48, 22.24],
								[4.06, 22.14],
								[4.66, 19.01],
								[5.21, 16.05],
								[5.07, 15.36],
								[4.33, 10.8],
								[4.13, 5.31],
								[4.04, 3.13],
								[3.37, 0.39],
								[3.37, 0.38]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 16
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 2",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [14.57, 3.06] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [640.29, 27.57] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[-0.76, -0.19],
								[-1.42, 0.1],
								[-1.09, 0.04],
								[-0.76, -0.1],
								[-0.11, 0.02],
								[-3.01, 0.08],
								[-0.68, 0.06],
								[-1.14, 0.55],
								[0.67, 0.19],
								[1.62, -0.12],
								[1.86, -0.06],
								[0.29, -0.11],
								[0, 0],
								[2.11, -0.18],
								[0.47, -0.04],
								[1.02, -0.44],
								[0, 0]
							],
							"o": [
								[-0.72, 0.31],
								[1.08, 0.26],
								[1.6, -0.25],
								[1.84, -0.16],
								[0.11, 0.01],
								[0.79, -0.16],
								[2.12, -0.19],
								[1.62, -0.16],
								[0.63, -0.31],
								[-1.22, -0.35],
								[-0.63, 0.05],
								[-0.3, 0.01],
								[-2.51, 0.99],
								[0, 0],
								[-1.59, 0.14],
								[-1.42, 0.14],
								[0, 0],
								[0, 0]
							],
							"v": [
								[0.45, 2.95],
								[0.69, 5.83],
								[4.31, 6.09],
								[7.36, 5.27],
								[13.13, 5.62],
								[13.46, 5.61],
								[20.7, 4.72],
								[24.81, 4.35],
								[28.75, 3.3],
								[28.53, 0.73],
								[24.46, 0.36],
								[20.63, 0],
								[19.74, 0.19],
								[13.87, 1.25],
								[6.78, 1.84],
								[3.96, 2.09],
								[0.44, 2.96],
								[0.45, 2.95]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 17
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 1",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [2.91, 15.55] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [639.61, 29.2] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[0.2, -0.81],
								[-0.08, -1.52],
								[-0.02, -1.17],
								[0.11, -0.81],
								[-0.01, -0.12],
								[-0.03, -3.2],
								[-0.05, -0.73],
								[-0.54, -1.24],
								[-0.2, 0.71],
								[0.09, 1.73],
								[0.03, 1.97],
								[0.11, 0.31],
								[0, 0],
								[0.14, 2.24],
								[0.03, 0.5],
								[0.42, 1.1],
								[0, 0]
							],
							"o": [
								[-0.3, -0.77],
								[-0.29, 1.14],
								[0.22, 1.71],
								[0.13, 1.97],
								[-0.01, 0.12],
								[0.14, 0.84],
								[0.15, 2.26],
								[0.13, 1.72],
								[0.29, 0.68],
								[0.37, -1.29],
								[-0.04, -0.67],
								[0, -0.32],
								[-0.95, -2.69],
								[0, 0],
								[-0.11, -1.69],
								[-0.11, -1.52],
								[0, 0],
								[0, 0]
							],
							"v": [
								[3.23, 0.51],
								[0.35, 0.69],
								[0.02, 4.54],
								[0.79, 7.82],
								[0.35, 13.95],
								[0.35, 14.31],
								[1.12, 22.04],
								[1.41, 26.43],
								[2.4, 30.66],
								[4.97, 30.49],
								[5.41, 26.17],
								[5.83, 22.09],
								[5.66, 21.14],
								[4.7, 14.87],
								[4.23, 7.3],
								[4.03, 4.29],
								[3.23, 0.51],
								[3.23, 0.51]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 18
		},
		{
			"ty": 4,
			"nm": "Vector",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "Vector 0",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [85.32, 78.54] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [12.27, 179.9] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, 0],
								[-0.63, 2.58],
								[0.28, 0.1],
								[1.11, -2.43],
								[1.63, -5.07],
								[1.72, -7.7],
								[0.13, -8.57],
								[-1.06, -4.47],
								[-1.07, -2.16],
								[-1.83, -1.77],
								[-2.43, -0.93],
								[-1.27, -0.25],
								[-1.29, -0.03],
								[-4.93, 1.73],
								[-4.18, 2.47],
								[-3.26, 2.43],
								[-4.53, 4.38],
								[-4.04, 4.72],
								[-4.48, 6.46],
								[-3.42, 6.78],
								[-1.45, 3.69],
								[-1.06, 3.95],
								[0.66, 8.38],
								[0, 0],
								[0, 0],
								[0.08, 0.52],
								[0.16, 0.6],
								[0.57, 1.03],
								[0.88, 0.8],
								[1.08, 0.48],
								[0.55, 0.21],
								[0.59, 0.05],
								[1.16, -0.14],
								[0.55, -0.2],
								[0, 0],
								[0, 0],
								[3.2, -2.22],
								[2.7, -2.47],
								[3.84, -4.81],
								[2.54, -3.87],
								[1.36, -2.33],
								[1.46, -2.85],
								[4.65, -13.22],
								[1.66, -8.41],
								[0.3, -4.64],
								[-0.91, -4.98],
								[-1.13, -2.43],
								[-2.08, -1.93],
								[-2.74, -0.73],
								[-2.76, 0.18],
								[-2.65, 0.71],
								[-2.54, 1.02],
								[-4.76, 2.76],
								[-4.53, 3.14],
								[-2.21, 1.64],
								[0, 0],
								[0, 0],
								[-0.09, 0.09],
								[0, 0],
								[0, 0],
								[-0.96, 1],
								[-3.28, 4.45],
								[-1.47, 2.33],
								[-1.25, 2.44],
								[-0.89, 7.11],
								[0.47, 3.41],
								[0.16, 0.83],
								[0.24, 0.81],
								[0.32, 0.8],
								[0.16, 0.39],
								[0.19, 0.38],
								[1.1, 1.24],
								[1.31, 0.94],
								[2.96, 0.59],
								[0.37, 0.05],
								[0.37, 0.05],
								[0.68, -0.03],
								[0.69, -0.01],
								[0.68, -0.05],
								[0.33, -0.03],
								[0.33, -0.05],
								[0.65, -0.1],
								[1.21, -0.42],
								[3.4, -2.86],
								[1.97, -3.22],
								[0.87, -4.97],
								[0.04, -2.9],
								[-0.37, -2.78],
								[-2.11, -4.89],
								[-1.41, -2.18],
								[0, 0],
								[0, 0],
								[-0.38, -0.51],
								[-0.86, -0.93],
								[-4.21, -2.42],
								[-4.54, -0.98],
								[-4.46, 0.16],
								[-4.25, 0.91],
								[-4.04, 1.42],
								[-1.58, 0.77],
								[-1.01, 0.6],
								[0.12, 0.24],
								[2.2, -0.77],
								[1.64, -0.58],
								[2.17, -0.77],
								[4.14, -0.79],
								[4.27, -0.07],
								[4.25, 0.98],
								[3.88, 2.29],
								[3.88, 9.16],
								[-1.84, 11.05],
								[-3.29, 5.7],
								[-2.8, 2.54],
								[-0.35, 0.32],
								[-0.38, 0.3],
								[-0.84, 0.56],
								[-2.02, 0.72],
								[-1.05, 0.33],
								[-0.55, 0.12],
								[0, 0],
								[0, 0],
								[-0.57, 0.08],
								[-0.58, 0.05],
								[0, 0],
								[0, 0],
								[-0.61, 0],
								[-3.34, -3.75],
								[-0.61, -1.12],
								[-0.15, -0.28],
								[-0.11, -0.31],
								[0, 0],
								[0, 0],
								[-0.12, -2.86],
								[2.19, -5.97],
								[4.87, -6.78],
								[3.15, -3.44],
								[1.69, -1.64],
								[0, 0],
								[0, 0],
								[0, 0],
								[0.97, -0.72],
								[8.48, -4.31],
								[4.4, -1.33],
								[4.23, 0.48],
								[1.75, 0.98],
								[1.2, 1.58],
								[0.63, 3.89],
								[-0.19, 3.73],
								[-0.57, 3.35],
								[-1.45, 4.79],
								[-0.95, 2.56],
								[0, 0],
								[-1.57, 3.66],
								[-3.29, 6.29],
								[-5.29, 7.68],
								[-7.78, 7.23],
								[-4.68, 2.72],
								[-1.23, 0.57],
								[-0.62, 0.25],
								[-0.27, 0.07],
								[-0.29, 0.04],
								[-1.94, -1.36],
								[-0.61, -1],
								[-0.18, -0.56],
								[-0.07, -0.29],
								[0, 0],
								[0, 0],
								[-0.06, -2.73],
								[1.11, -5.23],
								[1.87, -4.77],
								[2.24, -4.21],
								[4.49, -5.94],
								[6.15, -5.92],
								[5.1, -3.72],
								[6.13, -2.19],
								[4.52, 0.12],
								[1.08, 0.18],
								[0.99, 0.39],
								[1.47, 1.45],
								[0.93, 1.86],
								[0.5, 2.02],
								[0.01, 4.09],
								[-1.53, 7.6],
								[-2.15, 7.17],
								[0, 0]
							],
							"o": [
								[1.51, -5.06],
								[0.65, -2.57],
								[-0.28, -0.1],
								[-1.1, 2.43],
								[-2.32, 7.18],
								[-1.68, 7.7],
								[-0.04, 4.28],
								[0.53, 2.23],
								[1.06, 2.16],
								[1.81, 1.79],
								[1.21, 0.48],
								[1.27, 0.22],
								[5.17, 0.14],
								[5.59, -2],
								[4.18, -2.48],
								[6.5, -4.89],
								[4.53, -4.4],
								[4.04, -4.74],
								[3.76, -5.47],
								[1.72, -3.39],
								[1.47, -3.68],
								[2.11, -7.88],
								[0, 0],
								[0, 0],
								[-0.06, -0.52],
								[-0.09, -0.52],
								[-0.24, -1.16],
								[-0.61, -1.02],
								[-0.89, -0.77],
								[-0.52, -0.28],
								[-0.57, -0.13],
								[-1.16, -0.2],
								[-0.57, 0.13],
								[0, 0],
								[0, 0],
								[-3.78, 1.57],
								[-3.2, 2.21],
								[-5.4, 4.94],
								[-3.83, 4.82],
								[-2.54, 3.87],
								[-1.61, 2.76],
								[-2.6, 5.09],
								[-2.31, 6.61],
								[-0.82, 4.21],
								[-0.29, 4.63],
								[0.48, 2.48],
								[1.1, 2.43],
								[2.1, 1.9],
								[2.74, 0.76],
								[2.77, -0.18],
								[2.65, -0.71],
								[5.07, -2.05],
								[4.76, -2.77],
								[2.26, -1.59],
								[0, 0],
								[0, 0],
								[0.12, -0.08],
								[0, 0],
								[0, 0],
								[1, -0.97],
								[3.86, -4.01],
								[1.64, -2.23],
								[1.47, -2.33],
								[3.54, -6.87],
								[0.44, -3.55],
								[-0.14, -0.85],
								[-0.21, -0.83],
								[-0.27, -0.8],
								[-0.16, -0.4],
								[-0.19, -0.38],
								[-0.81, -1.49],
								[-1.1, -1.23],
								[-2.61, -1.87],
								[-0.37, -0.09],
								[-0.37, -0.05],
								[-0.73, -0.04],
								[-0.7, 0],
								[-0.69, 0.01],
								[-0.34, 0.03],
								[-0.33, 0.03],
								[-0.67, 0.1],
								[-1.28, 0.3],
								[-4.93, 1.45],
								[-3.37, 2.92],
								[-3.91, 6.5],
								[-0.52, 2.95],
								[-0.04, 2.89],
								[0.7, 5.57],
								[1.08, 2.43],
								[0, 0],
								[0, 0],
								[0.37, 0.53],
								[0.8, 1.01],
								[3.32, 3.84],
								[4.21, 2.43],
								[4.55, 0.97],
								[4.47, -0.16],
								[4.26, -0.91],
								[2.2, -0.84],
								[1.6, -0.74],
								[2.04, -1.17],
								[-0.12, -0.24],
								[-1.09, 0.38],
								[-1.62, 0.62],
								[-3.99, 1.3],
								[-4.14, 0.8],
								[-4.27, 0.07],
								[-4.24, -0.98],
								[-7.78, -4.52],
								[-3.88, -9.13],
								[0.73, -4.27],
								[1.66, -2.82],
								[0.35, -0.31],
								[0.35, -0.33],
								[0.75, -0.63],
								[1.72, -1.04],
								[0.98, -0.42],
								[0.53, -0.13],
								[0, 0],
								[0, 0],
								[0.56, -0.08],
								[0.58, -0.04],
								[0, 0],
								[0, 0],
								[0.59, 0],
								[4.55, 0.16],
								[0.81, 0.95],
								[0.18, 0.27],
								[0.14, 0.29],
								[0, 0],
								[0, 0],
								[0.84, 2.59],
								[0.25, 5.73],
								[-2.87, 7.8],
								[-2.64, 3.66],
								[-1.56, 1.73],
								[0, 0],
								[0, 0],
								[0, 0],
								[-0.95, 0.72],
								[-7.74, 5.65],
								[-4.23, 2.15],
								[-4.39, 1.31],
								[-2.09, -0.27],
								[-1.77, -0.96],
								[-2.43, -3.18],
								[-0.63, -3.92],
								[0.2, -3.73],
								[1.14, -6.7],
								[1.45, -4.79],
								[0.97, -2.56],
								[0, 0],
								[1.57, -3.66],
								[3.3, -6.28],
								[5.3, -7.66],
								[3.89, -3.6],
								[1.17, -0.68],
								[0.61, -0.29],
								[0.31, -0.14],
								[0.28, -0.08],
								[2.27, -0.57],
								[0.97, 0.67],
								[0.3, 0.5],
								[0.12, 0.27],
								[0, 0],
								[0, 0],
								[0.47, 2.69],
								[0.13, 5.45],
								[-1.11, 5.23],
								[-1.85, 4.78],
								[-4.5, 8.42],
								[-6.78, 8.95],
								[-6.16, 5.92],
								[-10.23, 7.44],
								[-4.64, 1.64],
								[-1.13, -0.02],
								[-1.07, -0.22],
								[-1.99, -0.76],
								[-1.5, -1.43],
								[-0.93, -1.86],
								[-0.99, -4.06],
								[0.04, -8.2],
								[1.57, -7.6],
								[0, 0],
								[0, 0]
							],
							"v": [
								[11.81, 64.13],
								[15.09, 52.69],
								[15.61, 48.67],
								[13.49, 52.14],
								[9.29, 63.35],
								[3.15, 85.59],
								[0, 109.91],
								[1.3, 123.08],
								[3.64, 129.71],
								[7.94, 135.72],
								[14.43, 139.84],
								[18.17, 140.88],
								[22.03, 141.28],
								[37.24, 138.53],
								[51.74, 131.58],
								[62.8, 124.16],
								[78.89, 110.36],
								[91.44, 96.96],
								[104.07, 80.58],
								[115.03, 62.18],
								[119.82, 51.57],
								[123.64, 40.11],
								[126.26, 15.43],
								[126.12, 13.87],
								[125.93, 12.31],
								[125.69, 10.75],
								[125.38, 9.14],
								[124.07, 5.84],
								[121.84, 3.1],
								[118.91, 1.15],
								[117.27, 0.5],
								[115.55, 0.13],
								[112.04, 0.13],
								[110.34, 0.54],
								[109.51, 0.81],
								[108.8, 1.1],
								[98.35, 6.92],
								[89.53, 14.01],
								[75.78, 28.92],
								[66.26, 42.12],
								[60.41, 51.55],
								[55.8, 59.97],
								[43.82, 87.77],
								[37.57, 110.34],
								[35.78, 123.61],
								[36.44, 138.09],
								[38.73, 145.51],
								[43.49, 152.2],
								[50.92, 156.27],
								[59.26, 157.02],
								[67.39, 155.64],
								[75.16, 153.01],
								[89.86, 145.66],
								[103.77, 136.73],
								[110.48, 131.89],
								[112.14, 130.65],
								[112.36, 130.49],
								[112.7, 130.2],
								[113.08, 129.83],
								[113.83, 129.1],
								[116.77, 126.14],
								[127.5, 113.42],
								[132.16, 106.59],
								[136.25, 99.44],
								[143.18, 78.36],
								[143.17, 67.85],
								[142.72, 65.32],
								[142.08, 62.86],
								[141.27, 60.47],
								[140.79, 59.28],
								[140.21, 58.14],
								[137.36, 54.01],
								[133.75, 50.74],
								[125.26, 47.04],
								[124.15, 46.84],
								[123.04, 46.69],
								[120.86, 46.59],
								[118.79, 46.61],
								[116.74, 46.75],
								[115.73, 46.83],
								[114.73, 46.97],
								[112.76, 47.27],
								[108.98, 48.22],
								[96.43, 55.07],
								[88.51, 64.47],
								[82.12, 82.09],
								[81.31, 90.87],
								[81.77, 99.4],
								[86.04, 115.16],
								[89.7, 122.13],
								[90.21, 122.95],
								[90.77, 123.75],
								[91.87, 125.33],
								[94.29, 128.3],
								[105.76, 137.7],
								[119.04, 142.71],
								[132.62, 143.84],
								[145.71, 142.15],
								[158.12, 138.52],
								[163.82, 136.17],
								[167.76, 134.19],
								[170.63, 132.05],
								[167.15, 132.82],
								[163.05, 134.28],
								[157.33, 136.29],
								[145.17, 139.56],
								[132.54, 140.93],
								[119.7, 139.65],
								[107.4, 134.83],
								[89.3, 113.74],
								[85.72, 82.7],
								[91.2, 67.3],
								[97.77, 59.03],
								[98.83, 58.08],
								[99.96, 57.18],
								[102.4, 55.47],
								[107.97, 52.72],
								[111.07, 51.72],
								[112.7, 51.36],
								[113.53, 51.18],
								[114.37, 51.06],
								[116.07, 50.82],
								[117.81, 50.69],
								[118.69, 50.63],
								[119.59, 50.63],
								[121.39, 50.63],
								[134.05, 56.52],
								[136.25, 59.59],
								[136.69, 60.44],
								[137.09, 61.31],
								[137.46, 62.2],
								[137.77, 63.18],
								[139.23, 71.4],
								[136.09, 89.17],
								[124.05, 111.08],
								[115.35, 121.77],
								[110.47, 126.82],
								[109.94, 127.33],
								[109.29, 127.83],
								[107.86, 128.92],
								[104.97, 131.06],
								[80.65, 146.37],
								[67.67, 151.69],
								[54.54, 153.23],
								[48.67, 151.41],
								[44.19, 147.52],
								[39.91, 136.46],
								[39.42, 124.89],
								[40.65, 114.25],
								[44.82, 96.93],
								[48.58, 85.82],
								[50.1, 81.89],
								[52.47, 76.17],
								[59.71, 60.97],
								[72.5, 39.67],
								[91.94, 16.7],
								[104.77, 7.01],
								[108.36, 5.12],
								[110.21, 4.29],
								[111.1, 3.95],
								[111.94, 3.69],
								[118.67, 4.96],
								[121.08, 7.51],
								[121.83, 9.1],
								[122.08, 9.95],
								[122.19, 10.38],
								[122.27, 10.88],
								[123.07, 19.02],
								[121.46, 35.13],
								[116.89, 50.17],
								[110.66, 63.66],
								[96.75, 85.27],
								[77.16, 107.34],
								[60.22, 121.64],
								[35.99, 135.07],
								[22.11, 137.64],
								[18.8, 137.31],
								[15.68, 136.45],
								[10.41, 133.14],
								[6.79, 128.12],
								[4.67, 122.25],
								[3.37, 109.93],
								[6.14, 86.22],
								[11.79, 64.12],
								[11.81, 64.13]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.8118, 0.8824, 0.9922] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 19
		},
		{
			"ty": 4,
			"nm": "Provisioning loader Bg",
			"sr": 1,
			"st": 0,
			"op": 241,
			"ip": 0,
			"hd": false,
			"ln": "undefined-bg",
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [334, 122] },
				"s": { "a": 0, "k": [100, 100] },
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [334, 122] },
				"r": { "a": 0, "k": 0 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[0, -6.62],
								[0, 0],
								[6.62, 0],
								[0, 0],
								[0, 6.62],
								[0, 0],
								[-6.62, 0],
								[0, 0]
							],
							"o": [
								[0, 0],
								[0, 6.62],
								[0, 0],
								[-6.62, 0],
								[0, 0],
								[0, -6.62],
								[0, 0],
								[6.62, 0]
							],
							"v": [
								[668, 12],
								[668, 232],
								[656, 244],
								[12, 244],
								[0, 232],
								[0, 12],
								[12, 0],
								[656, 0]
							]
						}
					}
				},
				{
					"ty": "fl",
					"bm": 0,
					"hd": false,
					"nm": "",
					"c": { "a": 0, "k": [0.9137, 0.949, 0.9961] },
					"r": 1,
					"o": { "a": 0, "k": 100 }
				}
			],
			"ind": 20
		}
	],
	"v": "5.7.0",
	"fr": 60,
	"op": 240,
	"ip": 0,
	"assets": [
		{
			"nm": "[Asset] Gestural Line/scribble 3",
			"id": "1",
			"fr": 30,
			"layers": [
				{
					"ty": 0,
					"nm": "Star 3",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Star 3 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.43, 20.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [19.03, 20.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"h": 1,
										"o": { "x": 0.167, "y": 0.167 },
										"i": { "x": 0.833, "y": 0.833 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.55],
													[0, 0],
													[0.55, 0],
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0],
													[0, -0.55],
													[0, 0],
													[0.55, 0]
												],
												"v": [
													[668, 1],
													[668, 243],
													[667, 244],
													[1, 244],
													[0, 243],
													[0, 1],
													[1, 0],
													[667, 0]
												]
											}
										],
										"t": 0
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.01],
													[0, 0],
													[0.01, 0],
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0],
													[0, -0.01],
													[0, 0],
													[0.01, 0]
												],
												"v": [
													[38.86, 0.01],
													[38.86, 41],
													[38.85, 41.01],
													[0.01, 41.01],
													[0, 41],
													[0, 0.01],
													[0.01, 0],
													[38.85, 0]
												]
											}
										],
										"t": 240
									}
								]
							}
						}
					],
					"w": 668,
					"h": 244,
					"refId": "2",
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Gestural Line/scribble 3 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Gestural Line/scribble 3 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.39, 20.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [19.39, 20.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[38.79, 0.01],
										[38.79, 40.28],
										[38.78, 40.29],
										[0.01, 40.29],
										[0, 40.28],
										[0, 0.01],
										[0.01, 0],
										[38.78, 0]
									]
								}
							}
						}
					],
					"ind": 2
				}
			]
		},
		{
			"nm": "[Asset] Star 3",
			"id": "2",
			"fr": 30,
			"layers": [
				{
					"ty": 4,
					"nm": "Group 6272483",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Group 6272483 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.17, 20.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [19.5, 20.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Layer_1-2",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Layer_1-2 1",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.17, 20.32] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [19.17, 20.32] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Vector 15",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.17, 6.66] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [19.17, 19.58] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1, 0.07],
										[-1.79, 0.51],
										[-1.42, 0.3],
										[-1.03, 0.02],
										[-0.14, 0.04],
										[-4.09, 0.95],
										[-0.91, 0.34],
										[-1.26, 1.22],
										[0.89, -0.14],
										[1.98, -0.71],
										[2.34, -0.54],
										[0.36, -0.2],
										[0, 0],
										[2.01, -0.42],
										[1.42, -0.35],
										[0.62, -0.18],
										[1.22, -0.9],
										[0, 0]
									],
									"o": [
										[-0.87, 0.62],
										[1.42, -0.13],
										[1.98, -0.71],
										[2.38, -0.58],
										[0.15, 0],
										[1.03, -0.34],
										[2.86, -0.79],
										[2.14, -0.82],
										[0.7, -0.66],
										[-1.62, 0.26],
										[-0.77, 0.29],
										[-0.38, 0.09],
										[-3.06, 1.72],
										[0, 0],
										[-2.02, 0.42],
										[-2.13, 0.54],
										[-1.9, 0.58],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.33, 10.29],
										[1.49, 13.31],
										[6.13, 12.41],
										[9.93, 10.76],
										[17.61, 10.03],
										[18.05, 9.96],
										[27.75, 7.38],
										[33.26, 5.59],
										[38.13, 2.57],
										[36.8, 0.01],
										[31.68, 1.39],
										[26.76, 2.2],
										[25.65, 2.64],
										[18.09, 5.02],
										[14.43, 5.78],
										[8.62, 7.08],
										[4.85, 8.11],
										[0.32, 10.3],
										[0.33, 10.29]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Vector 14",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [15.24, 14.16] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [22.66, 22.78] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.14, -0.71],
										[-0.26, -0.26],
										[-0.49, -0.46],
										[-0.94, -0.63],
										[-1.16, -0.92],
										[-1.01, -1.1],
										[-0.3, -0.41],
										[-0.12, -0.09],
										[-1.35, -1.21],
										[-1.3, -1.57],
										[-0.62, -0.7],
										[-1.46, -0.9],
										[0.38, 0.86],
										[1.46, 1.7],
										[1.66, 1.98],
										[0.35, 0.23],
										[1.2, 1.11],
										[0, 0],
										[1.63, 1.38],
										[1.21, 0.86],
										[0.54, 0.35],
										[1.79, 0.3],
										[0, 0]
									],
									"o": [
										[-0.66, -0.11],
										[-0.15, 0.73],
										[0.44, 0.42],
										[0.55, 0.5],
										[1.88, 1.1],
										[1.01, 0.73],
										[1.01, 1.1],
										[0.09, 0.12],
										[0.42, 0.32],
										[1.35, 1.2],
										[1.94, 2.12],
										[1.48, 1.66],
										[0.81, 0.5],
										[-0.7, -1.56],
										[-0.58, -0.66],
										[-0.27, -0.33],
										[-1.54, -1.03],
										[-1.19, -1.11],
										[0, 0],
										[-1.63, -1.38],
										[-1.82, -1.3],
										[-1.45, -0.96],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.41, 0.01],
										[0.11, 1.28],
										[0.2, 3.01],
										[1.58, 4.32],
										[3.68, 6],
										[7.47, 7.88],
										[10.69, 10.87],
										[12.82, 13.4],
										[13.14, 13.71],
										[16.05, 16.09],
										[20.26, 20.41],
										[24.01, 24.59],
										[28.25, 28.23],
										[30.43, 26.32],
										[27.39, 21.63],
										[24.45, 17.2],
										[23.51, 16.36],
										[19.21, 12.83],
										[17.19, 10.87],
										[14.27, 8.28],
										[9.43, 4.51],
										[6.15, 2.27],
										[1.41, 0.02],
										[1.41, 0.01]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Vector 13",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.34, 20.14] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [19.89, 20.14] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.06, -0.99],
										[-0.27, -2.01],
										[-0.26, -1.54],
										[-0.08, -1.05],
										[-0.05, -0.14],
										[-0.5, -1.76],
										[-0.18, -0.99],
										[-0.14, -1.03],
										[-0.12, -0.92],
										[-0.51, -1.58],
										[-0.29, 0.97],
										[0.29, 2.32],
										[0.35, 2.58],
										[0.18, 0.39],
										[0.43, 1.6],
										[0, 0],
										[0.54, 2.06],
										[0.28, 1.4],
										[0.1, 0.66],
										[0.72, 1.43],
										[0, 0]
									],
									"o": [
										[-0.52, -1.02],
										[-0.1, 1.44],
										[0.46, 2.27],
										[0.55, 2.61],
										[0.02, 0.15],
										[0.19, 0.52],
										[0.24, 0.88],
										[0.18, 1.01],
										[0.53, 2.94],
										[0.3, 2.17],
										[0.27, 0.86],
										[0.51, -1.74],
										[-0.11, -0.9],
										[-0.06, -0.42],
										[-0.72, -1.63],
										[-0.42, -1.62],
										[0, 0],
										[-0.54, -2.05],
										[-0.44, -2.1],
										[-0.3, -1.95],
										[0, 0],
										[0, 0]
									],
									"v": [
										[3.23, 0.5],
										[0.06, 1.19],
										[0.23, 6.11],
										[1.63, 10.44],
										[2.72, 18.53],
										[2.81, 18.98],
										[4, 22.66],
										[4.65, 25.51],
										[5.15, 28.7],
										[6.08, 34.31],
										[7.28, 39.59],
										[10.16, 39.59],
										[10.53, 33.71],
										[10.41, 28.24],
										[10.07, 27.03],
										[8.41, 21.61],
										[7.76, 18.83],
										[6.77, 15.06],
										[5.36, 9.24],
										[4.68, 5.47],
										[3.24, 0.5],
										[3.23, 0.5]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 5,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Vector 12",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [9.85, 18.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [20.01, 22.44] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, -0.04],
										[0, 0],
										[-0.14, 0.01],
										[0, 0],
										[0, 0],
										[0.02, 0.02],
										[0.14, 0.06],
										[0.32, -0.02],
										[0.28, -0.06],
										[0.1, -0.12],
										[-0.05, -0.38],
										[0, 0],
										[0, 0],
										[-0.08, 0.05],
										[-0.58, 0.76],
										[-0.39, 0.94],
										[-0.06, 0.59],
										[-0.29, 0.55],
										[-0.58, 0.84],
										[-0.06, 0.14],
										[-1.88, 3.5],
										[-0.39, 0.82],
										[-0.17, 0.44],
										[-0.14, 0.38],
										[-0.18, 1.03],
										[0.66, -0.04],
										[0.25, -0.24],
										[0.56, -0.7],
										[0.14, -0.22],
										[0.12, -0.21],
										[0.24, -0.49],
										[1.18, -2.23],
										[0.08, -0.41],
										[0.61, -1.43],
										[0, 0],
										[1.19, -2.58],
										[0.22, -0.56],
										[0.11, -0.28],
										[0.38, -0.78],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.02, 0],
										[-0.1, -0.04],
										[-0.27, -0.12],
										[-0.32, 0.02],
										[-0.14, 0.04],
										[-0.1, 0.11],
										[0, 0],
										[0, 0],
										[0.07, -0.01],
										[1.02, -0.52],
										[0.58, -0.78],
										[0.38, -1.1],
										[0.06, -0.58],
										[1.02, -2.25],
										[0.09, -0.13],
										[0.36, -0.99],
										[1.2, -2.54],
										[0.22, -0.49],
										[0.15, -0.41],
										[0.3, -0.82],
										[0.12, -0.58],
										[-0.67, 0.05],
										[-0.48, 0.47],
										[-0.14, 0.18],
										[-0.16, 0.24],
										[-0.24, 0.42],
										[-0.37, 0.77],
										[-0.19, 0.36],
										[-0.37, 1.77],
										[-0.6, 1.43],
										[0, 0],
										[-0.46, 1.1],
										[-0.21, 0.54],
										[-0.66, 1.66],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.98, 33.37],
										[0.96, 33.49],
										[2.3, 34.42],
										[2.48, 34.4],
										[2.62, 34.4],
										[2.81, 34.38],
										[2.74, 34.36],
										[2.38, 34.16],
										[1.44, 34.03],
										[0.53, 34.17],
										[0.16, 34.32],
										[0.01, 35.08],
										[0.17, 36.4],
										[2.66, 36.05],
										[2.9, 35.96],
										[5.2, 33.96],
										[6.61, 31.39],
										[7.12, 29.01],
										[7.52, 27.36],
										[11.56, 20.79],
										[11.77, 20.39],
										[15.58, 11.4],
										[17.91, 6.48],
										[18.5, 5.08],
										[18.94, 3.91],
										[19.69, 1.27],
										[18.56, 0],
										[17.04, 0.14],
										[15.42, 1.89],
										[14.99, 2.48],
										[14.6, 3.12],
										[13.88, 4.49],
										[10.99, 8.81],
										[10.58, 9.97],
										[8.95, 15.02],
										[7.82, 17.44],
										[3.82, 26.13],
										[2.91, 28.51],
										[2.44, 29.7],
										[0.98, 33.36],
										[0.98, 33.37]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 6,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Star 3 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 240,
					"hd": false,
					"ln": "Star 3 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.43, 20.5] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [19.43, 20.5] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[38.86, 0.01],
										[38.86, 41],
										[38.85, 41.01],
										[0.01, 41.01],
										[0, 41],
										[0, 0.01],
										[0.01, 0],
										[38.85, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 7
				}
			]
		},
		{
			"nm": "[Asset] Gestural Line/scribble 4",
			"id": "3",
			"fr": 30,
			"layers": [
				{
					"ty": 0,
					"nm": "Star 2",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Star 2 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [60.26, 30.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [60, 30.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.65, "y": 0 },
										"i": { "x": 0.35, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.55],
													[0, 0],
													[0.55, 0],
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0],
													[0, -0.55],
													[0, 0],
													[0.55, 0]
												],
												"v": [
													[668, 1],
													[668, 243],
													[667, 244],
													[1, 244],
													[0, 243],
													[0, 1],
													[1, 0],
													[667, 0]
												]
											}
										],
										"t": 0
									},
									{
										"o": { "x": 0.65, "y": 0 },
										"i": { "x": 0.35, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.01],
													[0, 0],
													[0.01, 0],
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0],
													[0, -0.01],
													[0, 0],
													[0.01, 0]
												],
												"v": [
													[120.52, 0.01],
													[120.52, 61.91],
													[120.51, 61.92],
													[0.01, 61.92],
													[0, 61.91],
													[0, 0.01],
													[0.01, 0],
													[120.51, 0]
												]
											}
										],
										"t": 186
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.01],
													[0, 0],
													[0.01, 0],
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0],
													[0, -0.01],
													[0, 0],
													[0.01, 0]
												],
												"v": [
													[120.52, 0.01],
													[120.52, 61.91],
													[120.51, 61.92],
													[0.01, 61.92],
													[0, 61.91],
													[0, 0.01],
													[0.01, 0],
													[120.51, 0]
												]
											}
										],
										"t": 222
									}
								]
							}
						}
					],
					"w": 668,
					"h": 244,
					"refId": "4",
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Gestural Line/scribble 4 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Gestural Line/scribble 4 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [60.21, 30.74] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [60.21, 30.74] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[120.41, 0.01],
										[120.41, 61.46],
										[120.4, 61.47],
										[0.01, 61.47],
										[0, 61.46],
										[0, 0.01],
										[0.01, 0],
										[120.4, 0]
									]
								}
							}
						}
					],
					"ind": 2
				}
			]
		},
		{
			"nm": "[Asset] Star 2",
			"id": "4",
			"fr": 30,
			"layers": [
				{
					"ty": 4,
					"nm": "Group 6272483",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Group 6272483 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [60.09, 30.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [60.36, 30.81] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Layer_1-2",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Layer_1-2 1",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [60.09, 30.7] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [60.09, 30.7] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 31",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [22.96, 27.59] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [84.3, 33.57] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.49, 3.7],
										[-2.69, 7.14],
										[-2.2, 5.42],
										[-1.22, 2.75],
										[-0.66, 1.37],
										[-0.34, 0.66],
										[0, 0],
										[-0.02, 0.03],
										[0, 0],
										[-0.04, 0.05],
										[-0.04, 0.04],
										[-0.03, -0.1],
										[-0.02, -0.11],
										[-0.01, -0.05],
										[0, 0],
										[0, 0],
										[-0.04, -0.15],
										[-0.11, -0.55],
										[-0.17, -0.98],
										[-0.12, -0.58],
										[-1.13, -7.11],
										[-0.46, -4.03],
										[-0.11, -2.01],
										[-0.01, -0.49],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.06, -0.02],
										[0.05, 0.04],
										[0, 0],
										[0.22, 0.17],
										[0.5, 0.41],
										[0.96, 0.7],
										[1.63, 0.92],
										[1.76, 0.69],
										[3.53, 0.58],
										[3.23, 0.03],
										[0.01, -0.4],
										[-1.73, -0.19],
										[-3.37, -0.72],
										[-3.96, -1.54],
										[-2.86, -1.72],
										[-1.64, -1.22],
										[-1.93, -1.61],
										[0, 0],
										[-0.33, -0.23],
										[-0.59, -0.06],
										[-0.29, 0.07],
										[-0.24, 0.17],
										[-0.09, 0.11],
										[-0.07, 0.13],
										[-0.07, 0.34],
										[0.02, 0.82],
										[0.04, 0.46],
										[0.1, 0.92],
										[0.25, 1.81],
										[0.48, 3.09],
										[0, 0],
										[0.49, 2.66],
										[0.37, 1.75],
										[0.22, 0.95],
										[0.12, 0.49],
										[0.09, 0.36],
										[0.13, 0.4],
										[0.4, 0.36],
										[0.26, 0.08],
										[0.08, 0.03],
										[0.07, -0.02],
										[0.12, -0.05],
										[0.47, -0.72],
										[0.11, -0.19],
										[0.1, -0.2],
										[0, 0],
										[0, 0],
										[0.82, -1.89],
										[1.05, -2.63],
										[0.9, -2.36],
										[1.65, -5.42],
										[0, 0]
									],
									"o": [
										[-1.16, 3.83],
										[2.12, -5.24],
										[2.98, -8.11],
										[0.92, -2.29],
										[0.61, -1.38],
										[0.33, -0.69],
										[0, 0],
										[0.04, -0.07],
										[0, 0],
										[0.04, -0.07],
										[0.04, -0.05],
										[0.03, -0.04],
										[0.05, 0.14],
										[0.01, 0.05],
										[0, 0],
										[0, 0],
										[0.04, 0.15],
										[0.13, 0.6],
										[0.44, 2.22],
										[0.1, 0.58],
										[0.43, 2.07],
										[0.56, 3.55],
										[0.23, 2.01],
										[0.03, 0.5],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.02, 0.06],
										[-0.07, 0.01],
										[0, 0],
										[-0.22, -0.18],
										[-0.53, -0.43],
										[-1.02, -0.82],
										[-1.93, -1.4],
										[-3.27, -1.85],
										[-4.17, -1.6],
										[-3.53, -0.57],
										[-1.78, -0.01],
										[-0.01, 0.42],
										[3.14, 0.35],
										[3.37, 0.73],
										[1.54, 0.59],
										[1.42, 0.86],
										[1.66, 1.22],
										[0, 0],
										[0.3, 0.24],
										[0.65, 0.46],
										[0.3, 0.04],
										[0.29, -0.06],
										[0.12, -0.09],
										[0.09, -0.11],
										[0.14, -0.26],
										[0.14, -0.75],
										[-0.02, -0.47],
										[-0.07, -0.92],
										[-0.2, -1.83],
										[-0.5, -3.62],
										[-0.96, -6.17],
										[0, 0],
										[-0.25, -1.33],
										[-0.18, -0.88],
										[-0.12, -0.48],
										[-0.09, -0.35],
										[-0.12, -0.41],
										[-0.26, -0.81],
										[-0.2, -0.19],
										[-0.07, -0.03],
										[-0.09, -0.01],
										[-0.13, 0.05],
										[-0.47, 0.15],
										[-0.12, 0.17],
										[-0.11, 0.19],
										[0, 0],
										[0, 0],
										[-0.96, 1.95],
										[-1.63, 3.79],
										[-3.14, 7.95],
										[-2.68, 7.16],
										[0, 0],
										[0, 0]
									],
									"v": [
										[14.64, 52],
										[16.59, 52.69],
										[23.57, 34.79],
										[29.21, 19.13],
										[32.47, 11.41],
										[34.37, 7.27],
										[35.37, 5.26],
										[35.5, 5.01],
										[35.55, 4.93],
										[35.61, 4.83],
										[35.74, 4.66],
										[35.86, 4.52],
										[36, 4.54],
										[36.09, 4.92],
										[36.1, 5.08],
										[36.1, 5.12],
										[36.15, 5.33],
										[36.25, 5.79],
										[36.61, 7.52],
										[37.51, 12.49],
										[37.83, 14.24],
										[40.5, 29.04],
										[42.1, 40.55],
										[42.63, 46.61],
										[42.69, 48.1],
										[42.69, 48.32],
										[42.69, 48.37],
										[42.69, 48.47],
										[42.61, 48.63],
										[42.44, 48.55],
										[42.34, 48.47],
										[41.68, 47.94],
										[40.14, 46.68],
										[37.16, 44.39],
										[31.81, 40.93],
										[24.22, 37.34],
										[12.72, 34.24],
										[2.68, 33.42],
										[0, 34.23],
										[2.58, 35.26],
										[12.24, 36.79],
										[23.18, 40.02],
										[29.89, 43.4],
										[34.51, 46.51],
										[39.79, 50.75],
										[40.35, 51.2],
										[41.3, 51.91],
										[43.21, 52.74],
										[44.08, 52.69],
										[44.91, 52.28],
										[45.21, 51.98],
										[45.46, 51.64],
										[45.78, 50.73],
										[45.9, 48.26],
										[45.81, 46.88],
										[45.55, 44.13],
										[44.86, 38.65],
										[43.35, 28.42],
										[41.62, 17.81],
										[40.83, 13.49],
										[39.9, 8.84],
										[39.3, 6.11],
										[38.94, 4.66],
										[38.66, 3.59],
										[38.29, 2.36],
										[37.27, 0.48],
										[36.62, 0.07],
										[36.39, 0],
										[36.17, 0.04],
										[35.8, 0.18],
										[34.36, 1.54],
										[34.02, 2.09],
										[33.69, 2.68],
										[33.37, 3.28],
										[33.08, 3.85],
										[30.44, 9.66],
										[26.34, 19.62],
										[20.88, 33.78],
										[14.65, 52],
										[14.64, 52]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 30",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [31.86, 14.48] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [87.74, 28.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.64, 0.66],
										[-1.26, 0.57],
										[-1.52, 0.74],
										[-0.9, 0.53],
										[-1.19, 0.51],
										[-1.7, 0.54],
										[-0.25, 0.11],
										[-6.68, 2.64],
										[-1.49, 0.63],
										[-0.75, 0.33],
										[-1.38, 0.74],
										[-1.2, 0.77],
										[1.46, -0.52],
										[1.43, -0.58],
										[1.76, -0.78],
										[1.42, -0.52],
										[2.04, -0.8],
										[0.63, -0.33],
										[2.55, -1.04],
										[0, 0],
										[3.35, -1.34],
										[2.3, -1.05],
										[0.66, -0.3],
										[0.49, -0.23],
										[0.51, -0.24],
										[1.22, -0.68],
										[1.06, -0.69],
										[0, 0]
									],
									"o": [
										[-1.5, 0.98],
										[1.17, -0.46],
										[1.27, -0.55],
										[1.7, -0.85],
										[0.91, -0.51],
										[3.99, -1.8],
										[0.25, -0.08],
										[1.72, -0.77],
										[2.34, -0.96],
										[1.48, -0.67],
										[1.77, -0.79],
										[1.38, -0.75],
										[1.32, -0.85],
										[-1.34, 0.47],
										[-1.44, 0.57],
										[-0.68, 0.3],
										[-1.43, 0.49],
										[-0.67, 0.26],
										[-2.72, 1.42],
										[-2.56, 1.04],
										[0, 0],
										[-3.34, 1.37],
										[-0.87, 0.39],
										[-0.66, 0.31],
										[-0.97, 0.46],
										[-1.53, 0.75],
										[-1.22, 0.7],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.78, 26.96],
										[1.75, 28.8],
										[5.36, 27.25],
										[9.5, 25.33],
										[13.14, 23.35],
										[16.01, 21.89],
										[28.73, 17.21],
										[29.47, 16.93],
										[45.52, 10.3],
										[51.24, 7.86],
										[54.56, 6.37],
										[59.21, 4.05],
										[63.02, 1.77],
										[62.19, 0.12],
										[58.1, 1.71],
										[53.38, 3.75],
										[50.18, 4.95],
										[44.95, 6.89],
										[43.01, 7.78],
										[34.49, 11.64],
										[30.07, 13.37],
										[23.95, 15.82],
										[14.39, 19.89],
										[12.11, 20.92],
										[10.41, 21.72],
										[8.26, 22.73],
										[4.17, 24.88],
										[0.8, 26.96],
										[0.78, 26.96]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 4,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 29",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [22.23, 23.41] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [97.95, 37.98] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.17, 0.27],
										[0.22, -0.06],
										[0.3, -0.56],
										[0.75, -0.98],
										[0.97, -1.2],
										[1.6, -1.78],
										[1.23, -1.1],
										[0.16, -0.18],
										[4.83, -4.48],
										[1.11, -1.01],
										[1.02, -0.98],
										[0.91, -0.82],
										[-0.14, -0.4],
										[-0.68, 0.37],
										[-1.17, 0.88],
										[-1.33, 1.2],
										[-3, 2.79],
										[-0.43, 0.51],
										[-1.78, 1.84],
										[0, 0],
										[-2.29, 2.44],
										[-1.54, 1.77],
										[-0.66, 0.82],
										[-0.7, 1.13],
										[-0.37, 1.29],
										[0, 0]
									],
									"o": [
										[0.13, -0.45],
										[-0.19, -0.3],
										[-0.47, 0.21],
										[-0.46, 0.82],
										[-0.76, 0.98],
										[-2.14, 2.77],
										[-2.65, 3.06],
										[-0.18, 0.16],
										[-1.15, 1.31],
										[-3.34, 3.23],
										[-1.31, 1.2],
										[-1.02, 0.98],
										[-0.5, 0.45],
										[0.13, 0.39],
										[1.22, -0.65],
										[1.16, -0.88],
										[1.03, -0.94],
										[0.49, -0.46],
										[1.85, -2.19],
										[1.78, -1.84],
										[0, 0],
										[2.29, -2.43],
										[2.31, -2.66],
										[0.98, -1.24],
										[0.69, -1.14],
										[0, 0],
										[0, 0]
									],
									"v": [
										[44.4, 1.5],
										[44.29, 0.31],
										[43.61, 0.02],
										[42.46, 0.78],
										[40.55, 3.51],
										[37.97, 6.76],
										[33.91, 12.19],
										[24.99, 20.98],
										[24.47, 21.5],
										[13.33, 32.95],
										[6.76, 39.14],
										[3.31, 42.38],
										[0.46, 45.11],
										[0.07, 46.4],
										[1.5, 46.64],
										[4.99, 44.35],
										[8.69, 41.26],
										[15.15, 35.88],
										[16.52, 34.43],
										[22.41, 28.02],
										[25.5, 24.88],
										[29.72, 20.46],
										[36.19, 13.35],
										[40.22, 8.54],
										[42.73, 5],
										[44.4, 1.49],
										[44.4, 1.5]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 5,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 28",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [8.96, 22.15] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [15.15, 23.99] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.55, 1.07],
										[-0.79, 2.14],
										[-0.66, 1.63],
										[-0.55, 1.09],
										[-0.06, 0.17],
										[-1.87, 4.5],
										[-0.37, 1.05],
										[-0.3, 1.94],
										[0.5, -0.94],
										[0.91, -2.44],
										[1.14, -2.75],
										[0.12, -0.47],
										[0, 0],
										[1.21, -3.21],
										[0.26, -0.72],
										[0.29, -1.71],
										[0, 0]
									],
									"o": [
										[-0.21, 1.2],
										[0.77, -1.53],
										[0.8, -2.46],
										[1.05, -2.79],
										[0.08, -0.16],
										[0.41, -1.22],
										[1.23, -3.21],
										[0.9, -2.48],
										[0.16, -1.06],
										[-0.91, 1.72],
										[-0.35, 0.95],
										[-0.18, 0.45],
										[-0.99, 4.08],
										[0, 0],
										[-0.91, 2.41],
										[-0.78, 2.18],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.02, 43.07],
										[1.99, 43.72],
										[4.25, 38.42],
										[5.62, 33.6],
										[9.53, 25.23],
										[9.74, 24.73],
										[13.88, 13.69],
										[16.23, 7.43],
										[17.9, 1.08],
										[16.14, 0.51],
										[13.54, 6.44],
										[10.93, 11.98],
										[10.48, 13.36],
										[7.34, 22.41],
										[3.13, 33.13],
										[1.54, 37.43],
										[0.02, 43.07],
										[0.02, 43.07]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 6,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 27",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [5.38, 19.71] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [27.21, 19.71] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.03, -1.05],
										[-0.32, -1.96],
										[-0.23, -1.51],
										[-0.12, -1.05],
										[-0.05, -0.15],
										[-0.99, -4.07],
										[-0.27, -0.91],
										[-0.82, -1.47],
										[0.11, 0.91],
										[0.62, 2.14],
										[0.59, 2.47],
										[0.17, 0.38],
										[0.4, 1.54],
										[0, 0],
										[0.43, 2.04],
										[0.27, 1.43],
										[0.11, 0.63],
										[0.46, 1.4],
										[0, 0]
									],
									"o": [
										[-0.32, -0.99],
										[-0.05, 1.49],
										[0.45, 2.21],
										[0.46, 2.52],
										[0.02, 0.15],
										[0.3, 1.07],
										[0.77, 2.85],
										[0.66, 2.16],
										[0.45, 0.81],
										[-0.2, -1.66],
										[-0.25, -0.83],
										[-0.1, -0.4],
										[-0.72, -1.64],
										[-0.4, -1.55],
										[0, 0],
										[-0.44, -2.04],
										[-0.4, -2.15],
										[-0.33, -1.93],
										[0, 0],
										[0, 0]
									],
									"v": [
										[2.06, 0.63],
										[0.01, 0.92],
										[0.37, 5.92],
										[1.52, 10.11],
										[2.54, 18.03],
										[2.63, 18.48],
										[5.26, 28.29],
										[6.84, 33.81],
										[9, 39],
										[10.76, 38.42],
										[9.6, 32.99],
										[8.63, 27.84],
										[8.23, 26.67],
										[6.5, 21.53],
										[5.87, 18.85],
										[5.05, 15.13],
										[3.89, 9.27],
										[3.21, 5.44],
										[2.06, 0.63],
										[2.06, 0.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 7,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 26",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [17.09, 11.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [17.09, 30.07] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0.62, 0.92],
										[0.25, 0.32],
										[0.29, 0.31],
										[0.33, 0.32],
										[0.39, 0.32],
										[0.34, 0.2],
										[0.28, 0.14],
										[0.6, 0.46],
										[0.83, 0.63],
										[0.13, 0.08],
										[3.56, 2.11],
										[0.83, 0.44],
										[1.63, 0.44],
										[-0.71, -0.54],
										[-1.95, -1.05],
										[-2.17, -1.29],
										[-0.38, -0.14],
										[-1.38, -0.77],
										[0, 0],
										[-0.58, -0.36],
										[-0.87, -0.55],
										[-0.86, -0.58],
										[-0.58, -0.41],
										[-0.49, -0.36],
										[-0.25, -0.19],
										[-0.34, -0.26],
										[-0.31, -0.23],
										[-0.29, -0.22],
										[-0.29, -0.2],
										[0, 0]
									],
									"o": [
										[0.79, 0.57],
										[-0.22, -0.32],
										[-0.25, -0.32],
										[-0.29, -0.3],
										[-0.34, -0.3],
										[-0.46, -0.34],
										[-0.34, -0.19],
										[-0.55, -0.28],
										[-2.09, -1.47],
										[-0.12, -0.1],
										[-0.97, -0.53],
										[-2.56, -1.42],
										[-1.98, -1.04],
										[-0.91, -0.24],
										[1.3, 1],
										[0.76, 0.4],
										[0.35, 0.21],
										[1.67, 0.61],
										[1.37, 0.79],
										[0, 0],
										[0.58, 0.36],
										[0.86, 0.56],
										[0.86, 0.59],
										[0.87, 0.63],
										[0.47, 0.37],
										[0.37, 0.3],
										[0.33, 0.27],
										[0.31, 0.24],
										[0.28, 0.23],
										[0, 0],
										[0, 0]
									],
									"v": [
										[32.5, 22.23],
										[34.02, 20.82],
										[33.33, 19.86],
										[32.51, 18.95],
										[31.58, 18.02],
										[30.48, 17.1],
										[29.3, 16.3],
										[28.38, 15.81],
										[26.77, 14.82],
										[20.47, 9.99],
										[20.09, 9.73],
										[11.29, 4.82],
										[6.3, 2.11],
										[1.12, 0.03],
										[0.31, 1.69],
										[4.95, 4.65],
										[9.26, 7.54],
										[10.37, 8.07],
										[15.22, 10.39],
										[17.55, 11.8],
										[18.49, 12.38],
										[20.74, 13.79],
										[23.4, 15.54],
										[25.64, 17.08],
										[27.63, 18.53],
										[28.68, 19.36],
										[29.76, 20.18],
										[30.71, 20.92],
										[31.63, 21.59],
										[32.48, 22.23],
										[32.5, 22.23]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 8,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 25",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [21.67, 3.95] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [21.9, 17.83] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-1.12, 0],
										[-2.1, 0.3],
										[-1.62, 0.19],
										[-1.13, 0.03],
										[-0.16, 0.03],
										[-4.48, 0.5],
										[-1.02, 0.15],
										[-1.72, 0.61],
										[0.99, 0.02],
										[2.4, -0.33],
										[2.75, -0.31],
										[0.44, -0.12],
										[0, 0],
										[3.14, -0.42],
										[0.7, -0.1],
										[1.52, -0.5],
										[0, 0]
									],
									"o": [
										[-1.08, 0.35],
										[1.59, 0],
										[2.37, -0.44],
										[2.73, -0.39],
										[0.17, 0],
										[1.17, -0.23],
										[3.15, -0.46],
										[2.41, -0.36],
										[0.94, -0.33],
										[-1.8, -0.04],
										[-0.93, 0.14],
										[-0.45, 0.05],
										[-3.75, 1.08],
										[0, 0],
										[-2.36, 0.35],
										[-2.11, 0.32],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0.67, 5.85],
										[1.01, 7.9],
										[6.36, 7.48],
										[10.9, 6.42],
										[19.45, 5.85],
										[19.95, 5.8],
										[30.74, 4.14],
										[36.87, 3.26],
										[42.76, 1.83],
										[42.46, 0.01],
										[36.45, 0.41],
										[30.77, 0.73],
										[29.45, 1],
										[20.7, 2.59],
										[10.13, 4.02],
										[5.94, 4.64],
										[0.68, 5.85],
										[0.67, 5.85]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 9,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Vector 24",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [19.02, 16.05] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [24.65, 30.1] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.09, -0.63],
										[1.88, -1.46],
										[1.46, -1.1],
										[1.05, -0.71],
										[0.14, -0.12],
										[3.9, -3.23],
										[0.86, -0.78],
										[1.22, -1.61],
										[-0.92, 0.62],
										[-2.01, 1.8],
										[-2.38, 1.97],
										[-0.34, 0.37],
										[0, 0],
										[-1.98, 1.59],
										[-1.39, 1.1],
										[-0.62, 0.49],
										[-1.23, 1.3],
										[0, 0]
									],
									"o": [
										[0.87, -0.92],
										[-1.54, 0.9],
										[-2.07, 1.74],
										[-2.44, 1.91],
										[-0.16, 0.1],
										[-1, 0.89],
										[-2.7, 2.34],
										[-2.01, 1.84],
										[-0.68, 0.89],
										[1.66, -1.13],
										[0.78, -0.71],
										[0.39, -0.32],
										[2.89, -3.24],
										[0, 0],
										[1.99, -1.57],
										[2.09, -1.65],
										[1.87, -1.48],
										[0, 0],
										[0, 0]
									],
									"v": [
										[37.73, 1.79],
										[36.45, 0.16],
										[31.49, 3.57],
										[27.63, 7.1],
										[19.76, 12.61],
										[19.31, 12.95],
										[10.02, 20.97],
										[4.83, 25.59],
										[0.22, 30.57],
										[1.49, 31.91],
										[6.76, 27.72],
										[11.81, 23.89],
										[12.89, 22.84],
										[20.24, 16.19],
										[23.84, 13.29],
										[29.55, 8.77],
										[33.27, 5.84],
										[37.74, 1.8],
										[37.73, 1.79]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 10,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Star 2 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 186,
					"hd": false,
					"ln": "Star 2 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [60.26, 30.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [60.26, 30.96] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[120.52, 0.01],
										[120.52, 61.91],
										[120.51, 61.92],
										[0.01, 61.92],
										[0, 61.91],
										[0, 0.01],
										[0.01, 0],
										[120.51, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 11
				}
			]
		},
		{
			"nm": "[Asset] Gestural Line/scribble 2",
			"id": "5",
			"fr": 30,
			"layers": [
				{
					"ty": 0,
					"nm": "Scribble 4",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 132,
					"hd": false,
					"ln": "Scribble 4 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [44.2, 15.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [42.6, 15.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.65, "y": 0 },
										"i": { "x": 0.35, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.55],
													[0, 0],
													[0.55, 0],
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0],
													[0, -0.55],
													[0, 0],
													[0.55, 0]
												],
												"v": [
													[668, 1],
													[668, 243],
													[667, 244],
													[1, 244],
													[0, 243],
													[0, 1],
													[1, 0],
													[667, 0]
												]
											}
										],
										"t": 0
									},
									{
										"o": { "x": 0.65, "y": 0 },
										"i": { "x": 0.35, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.01],
													[0, 0],
													[0.01, 0],
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0],
													[0, -0.01],
													[0, 0],
													[0.01, 0]
												],
												"v": [
													[88.4, 0.01],
													[88.4, 30.4],
													[88.39, 30.41],
													[0.01, 30.41],
													[0, 30.4],
													[0, 0.01],
													[0.01, 0],
													[88.39, 0]
												]
											}
										],
										"t": 132
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.01],
													[0, 0],
													[0.01, 0],
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0],
													[0, -0.01],
													[0, 0],
													[0.01, 0]
												],
												"v": [
													[88.4, 0.01],
													[88.4, 30.4],
													[88.39, 30.41],
													[0.01, 30.41],
													[0, 30.4],
													[0, 0.01],
													[0.01, 0],
													[88.39, 0]
												]
											}
										],
										"t": 168
									}
								]
							}
						}
					],
					"w": 668,
					"h": 244,
					"refId": "6",
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Gestural Line/scribble 2 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Gestural Line/scribble 2 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [42.99, 15.56] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [42.99, 15.56] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[85.98, 0.01],
										[85.98, 31.11],
										[85.97, 31.12],
										[0.01, 31.12],
										[0, 31.11],
										[0, 0.01],
										[0.01, 0],
										[85.97, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 2
				}
			]
		},
		{
			"nm": "[Asset] Scribble 4",
			"id": "6",
			"fr": 30,
			"layers": [
				{
					"ty": 4,
					"nm": "Group 6272481",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 132,
					"hd": false,
					"ln": "Group 6272481 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [43.75, 15.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [43.92, 15.22] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Layer_1-2",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 132,
					"hd": false,
					"ln": "Layer_1-2 1",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [43.75, 15.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [43.75, 15.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [],
					"ind": 2,
					"parent": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 132,
					"hd": false,
					"ln": "Vector 3",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [43.75, 15.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [43.75, 15.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.17, 0.32],
										[-0.03, 0.27],
										[0.3, 0.22],
										[0.48, -0.12],
										[0.26, -0.15],
										[0.3, -0.26],
										[2.34, -1.26],
										[3.03, -1.18],
										[1.9, -0.64],
										[2.47, -0.25],
										[2.38, 0.44],
										[1.26, 1.47],
										[-0.03, 1.67],
										[-0.02, 0.37],
										[-0.03, 0.18],
										[-0.02, 0.09],
										[-0.01, 0.02],
										[-0.02, -0.02],
										[-0.2, 0.13],
										[-0.15, 0.07],
										[-1.2, -0.32],
										[-0.67, -0.73],
										[-0.34, -1.19],
										[0.25, -1.26],
										[0.95, -0.94],
										[0, 0],
										[0.15, -0.13],
										[0, 0],
										[0.35, -0.23],
										[0, 0],
										[0.78, -0.36],
										[0.8, -0.29],
										[3.03, -0.58],
										[1.58, -0.1],
										[3.05, -0.02],
										[2.8, 0.03],
										[-3.09, -0.62],
										[-3.15, -0.23],
										[-3.94, 0.29],
										[-1.18, 0.06],
										[-1.57, 0.17],
										[-4.38, 1.7],
										[-0.7, 0.31],
										[-0.66, 0.38],
										[-0.34, 0.22],
										[-0.34, 0.24],
										[-0.66, 0.56],
										[-0.67, 0.54],
										[-0.35, 0.34],
										[-0.27, 0.42],
										[-0.37, 0.9],
										[-0.09, 0.92],
										[0.45, 1.56],
										[1.9, 1.1],
										[0.4, 0.18],
										[0.3, 0.06],
										[0.16, 0.02],
										[0, 0],
										[0.24, 0.02],
										[0.45, -0.06],
										[1.29, -0.73],
										[0.35, -0.22],
										[0.46, -0.36],
										[0.11, -0.63],
										[0.06, -0.52],
										[0.01, -0.46],
										[-0.05, -0.49],
										[-0.38, -1.04],
										[-1.87, -1.33],
										[-1.98, -0.37],
										[-1.71, 0.06],
										[-0.76, 0.06],
										[-0.65, 0.07],
										[-2.11, 0.65],
										[-1.08, 0.42],
										[-2.45, 1.55],
										[-1.78, 2.01],
										[0, 0]
									],
									"o": [
										[0.31, -0.36],
										[0.16, -0.34],
										[0.07, -0.54],
										[-0.3, -0.22],
										[-0.25, 0.06],
										[-0.29, 0.14],
										[-1.78, 1.45],
										[-2.34, 1.25],
										[-3.42, 1.38],
										[-1.92, 0.58],
										[-2.08, 0.2],
										[-2.4, -0.4],
										[-1.23, -1.5],
										[0.02, -0.42],
										[0.03, -0.19],
										[0.02, -0.09],
										[0.02, -0.13],
										[0.03, -0.01],
										[0, 0.02],
										[0.16, -0.11],
										[0.55, -0.31],
										[0.61, 0.14],
										[0.66, 0.73],
										[0.36, 1.18],
										[-0.25, 1.26],
										[0, 0],
										[-0.11, 0.11],
										[0, 0],
										[-0.34, 0.25],
										[0, 0],
										[-0.73, 0.45],
										[-0.78, 0.36],
										[-4.36, 1.91],
										[-3.06, 0.51],
										[-3.72, 0.3],
										[-3.05, 0.04],
										[-3.07, -0.06],
										[2.81, 0.54],
										[3.15, 0.25],
										[0.77, -0.05],
										[1.18, -0.04],
										[3.12, -0.38],
										[0.7, -0.29],
										[0.67, -0.36],
										[0.35, -0.22],
										[0.34, -0.24],
										[0.68, -0.5],
										[0.66, -0.54],
										[0.34, -0.26],
										[0.32, -0.39],
										[0.61, -0.8],
										[0.31, -0.92],
										[0.23, -1.85],
										[-0.93, -3.14],
										[-0.46, -0.3],
										[-0.42, -0.14],
										[-0.3, -0.06],
										[-0.16, -0.03],
										[0, 0],
										[-0.24, 0],
										[-0.9, 0.06],
										[-0.34, 0.16],
										[-0.42, 0.26],
										[-0.64, 0.29],
										[-0.06, 0.5],
										[-0.07, 0.42],
										[0.01, 0.46],
										[0.14, 0.98],
										[0.65, 2.06],
										[1.86, 1.35],
										[1.98, 0.38],
										[0.86, 0],
										[0.77, -0.04],
										[3.92, -0.54],
										[2.1, -0.65],
										[3.25, -1.28],
										[2.44, -1.56],
										[0, 0],
										[0, 0]
									],
									"v": [
										[86.48, 6.64],
										[87.2, 5.62],
										[87.48, 4.69],
										[87.09, 3.53],
										[85.88, 3.38],
										[85.12, 3.7],
										[84.22, 4.31],
										[78.02, 8.3],
										[70.01, 11.95],
										[62.5, 14.74],
										[56.44, 16.05],
										[49.52, 15.85],
										[43.67, 12.87],
										[42.16, 7.77],
										[42.21, 6.58],
										[42.31, 6.02],
										[42.36, 5.75],
										[42.38, 5.68],
										[42.48, 5.7],
										[42.7, 5.58],
										[43.16, 5.3],
										[45.88, 4.83],
										[47.88, 6.14],
										[49.5, 9.09],
										[49.7, 12.87],
										[47.88, 16.25],
										[47.5, 16.59],
										[47.02, 16.97],
										[46, 17.73],
										[44.96, 18.48],
										[43.87, 19.15],
										[41.64, 20.42],
										[39.35, 21.5],
										[28.12, 24.87],
										[21.19, 25.73],
										[11.13, 26.11],
										[2.47, 26.08],
										[2.16, 28.95],
										[10.99, 30.17],
										[21.52, 30.22],
										[24.44, 30.05],
										[28.56, 29.7],
										[39.97, 26.96],
										[42.08, 26.06],
										[44.07, 24.93],
										[45.12, 24.29],
										[46.16, 23.57],
										[48.24, 22.08],
										[50.24, 20.45],
										[51.32, 19.44],
										[52.26, 18.27],
										[53.66, 15.66],
										[54.32, 12.88],
										[53.84, 7.7],
										[49, 1.15],
										[47.67, 0.5],
										[46.58, 0.18],
										[45.88, 0.06],
										[45.63, 0.02],
										[45.26, 0.01],
										[44.22, 0.04],
										[40.76, 1.14],
										[39.78, 1.75],
										[38.43, 2.81],
										[37.79, 4.44],
										[37.61, 5.98],
										[37.57, 7.33],
										[37.6, 8.75],
										[38.23, 11.79],
										[42.16, 17.22],
										[48.1, 19.68],
										[53.69, 20.13],
										[56.12, 20],
										[58.24, 19.77],
										[67.06, 17.78],
										[71.66, 16.17],
										[80.13, 11.91],
										[86.48, 6.66],
										[86.48, 6.64]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Scribble 4 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 132,
					"hd": false,
					"ln": "Scribble 4 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [44.2, 15.2] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [44.2, 15.2] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[88.4, 0.01],
										[88.4, 30.4],
										[88.39, 30.41],
										[0.01, 30.41],
										[0, 30.4],
										[0, 0.01],
										[0.01, 0],
										[88.39, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 4
				}
			]
		},
		{
			"nm": "[Asset] Gestural Line/scribble 1",
			"id": "7",
			"fr": 30,
			"layers": [
				{
					"ty": 0,
					"nm": "Scribble 1",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 78,
					"hd": false,
					"ln": "Scribble 1 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": true,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [88.66, 21.64] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [87.06, 20.04] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"masksProperties": [
						{
							"nm": "",
							"inv": false,
							"mode": "a",
							"x": { "a": 0, "k": 0 },
							"o": { "a": 0, "k": 100 },
							"pt": {
								"a": 1,
								"k": [
									{
										"o": { "x": 0.65, "y": 0 },
										"i": { "x": 0.35, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.55],
													[0, 0],
													[0.55, 0],
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.55],
													[0, 0],
													[-0.55, 0],
													[0, 0],
													[0, -0.55],
													[0, 0],
													[0.55, 0]
												],
												"v": [
													[668, 1],
													[668, 243],
													[667, 244],
													[1, 244],
													[0, 243],
													[0, 1],
													[1, 0],
													[667, 0]
												]
											}
										],
										"t": 0
									},
									{
										"o": { "x": 0.65, "y": 0 },
										"i": { "x": 0.35, "y": 1 },
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.01],
													[0, 0],
													[0.01, 0],
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0],
													[0, -0.01],
													[0, 0],
													[0.01, 0]
												],
												"v": [
													[177.33, 0.01],
													[177.33, 43.26],
													[177.32, 43.27],
													[0.01, 43.27],
													[0, 43.26],
													[0, 0.01],
													[0.01, 0],
													[177.32, 0]
												]
											}
										],
										"t": 78
									},
									{
										"s": [
											{
												"c": true,
												"i": [
													[0, -0.01],
													[0, 0],
													[0.01, 0],
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0]
												],
												"o": [
													[0, 0],
													[0, 0.01],
													[0, 0],
													[-0.01, 0],
													[0, 0],
													[0, -0.01],
													[0, 0],
													[0.01, 0]
												],
												"v": [
													[177.33, 0.01],
													[177.33, 43.26],
													[177.32, 43.27],
													[0.01, 43.27],
													[0, 43.26],
													[0, 0.01],
													[0.01, 0],
													[177.32, 0]
												]
											}
										],
										"t": 114
									}
								]
							}
						}
					],
					"w": 668,
					"h": 244,
					"refId": "8",
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Group 626882",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 78,
					"hd": false,
					"ln": "Group 626882 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [87.36, 20.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [87.36, 20.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [],
					"ind": 2
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 78,
					"hd": false,
					"ln": "Vector 1",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [87.36, 20.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [87.36, 20.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[10.71, 6.92],
										[-26.09, -25.73],
										[12.74, 10.47],
										[-13.15, -32.72],
										[8.14, 1.08],
										[-1.73, -0.68],
										[3.65, 0.71],
										[-0.34, 0.09],
										[3.14, 3.86],
										[5.14, 6.42],
										[3.73, -2.56],
										[-0.12, 0.1],
										[-4.14, -5.39],
										[10.47, 1.16],
										[-2.13, -0.19],
										[0, 0],
										[-7.22, 6.46],
										[-1.79, 1.09],
										[4.41, 2.18],
										[-8.08, 8.34],
										[-13.66, 4.74],
										[0, 0],
										[-3.33, 2.95],
										[-5.79, 9.35],
										[0, 0]
									],
									"o": [
										[-12.23, 2.62],
										[17.37, -30.65],
										[-12.75, 9.08],
										[29.03, -33.6],
										[-1.54, 2.02],
										[1.73, 0.42],
										[-3.84, 0.62],
										[0.18, -0.59],
										[-3.12, -0.3],
										[4.32, -3.71],
										[-3.68, -2.93],
										[0.09, -0.14],
										[-6.3, 2.9],
										[-9.53, 6.42],
										[0.02, 0.88],
										[0, 0],
										[10.18, -0.6],
										[0.02, 0.62],
										[0.66, 1.06],
										[11.3, 11.18],
										[11.76, 10.71],
										[0, 0],
										[3.13, -1.1],
										[8.33, 5.8],
										[0, 0],
										[0, 0]
									],
									"v": [
										[174.71, 30.23],
										[137.68, 23.67],
										[131.93, 23.55],
										[84.9, 25.2],
										[79.44, 24.54],
										[53.86, 34.12],
										[60.14, 34.33],
										[48.66, 34.28],
										[51.26, 34.15],
										[35.81, 27.16],
										[46.17, 8.9],
										[34.42, 9.17],
										[35.38, 8.11],
										[31.77, 26.36],
										[0, 38.75],
										[4.3, 40.15],
										[3.5, 40.48],
										[30.64, 29.47],
										[33.63, 28.62],
										[36.19, 31.45],
										[82.07, 27.91],
										[126.58, 32.15],
										[126.22, 32.15],
										[135.45, 26.09],
										[174.71, 30.21],
										[174.71, 30.23]
									]
								}
							}
						},
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-8, -5.63],
										[3.8, -3.55]
									],
									"o": [
										[-5.14, -6.94],
										[0.21, 5.69],
										[0, 0]
									],
									"v": [
										[33.93, 24.75],
										[44.96, 11.01],
										[33.93, 24.75]
									]
								}
							}
						},
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.02, 0.02],
										[-9.1, -4.14],
										[0.78, -0.86],
										[4.01, -3.17]
									],
									"o": [
										[0, 0],
										[-5.58, -6.06],
										[-1.5, -1.22],
										[12.7, -6.73],
										[0, 0]
									],
									"v": [
										[81.5, 22.57],
										[81.55, 22.51],
										[90.35, 3.59],
										[84.61, 5.16],
										[81.5, 22.57]
									]
								}
							}
						},
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[1.4, -1.53],
										[1.11, 2.7],
										[-0.04, 0.36],
										[0, 0],
										[-4.2, -5.29],
										[0.03, -0.02],
										[0.71, -2.86]
									],
									"o": [
										[-0.48, 1.91],
										[-2.3, -1.84],
										[-0.16, 0.22],
										[0, 0],
										[-2.94, -5.56],
										[0, -0.03],
										[1.53, 2.49],
										[0, 0]
									],
									"v": [
										[137.35, 15.89],
										[134.38, 21.27],
										[128.71, 14.31],
										[128.26, 13.91],
										[128.56, 13.92],
										[136.7, 7.68],
										[136.02, 7.33],
										[137.35, 15.89]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 3,
					"parent": 2
				},
				{
					"ty": 4,
					"nm": "Gestural Line/scribble 1 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Gestural Line/scribble 1 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [87.36, 20.24] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [87.36, 20.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[174.71, 0.01],
										[174.71, 40.47],
										[174.7, 40.48],
										[0.01, 40.48],
										[0, 40.47],
										[0, 0.01],
										[0.01, 0],
										[174.7, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 4
				}
			]
		},
		{
			"nm": "[Asset] Scribble 1",
			"id": "8",
			"fr": 30,
			"layers": [
				{
					"ty": 4,
					"nm": "Scribble 1 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 78,
					"hd": false,
					"ln": "Scribble 1 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [88.66, 21.64] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [88.66, 21.64] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[177.33, 0.01],
										[177.33, 43.26],
										[177.32, 43.27],
										[0.01, 43.27],
										[0, 43.26],
										[0, 0.01],
										[0.01, 0],
										[177.32, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [1, 1, 1] },
							"r": 1,
							"o": { "a": 0, "k": 0 }
						}
					],
					"ind": 1
				}
			]
		},
		{
			"nm": "[Asset] Gestural Line/symbol check 2",
			"id": "9",
			"fr": 30,
			"layers": [
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Vector 1",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [24.22, 23.72] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [23.72, 23.21] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": {
							"a": 1,
							"k": [
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 0 },
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 6 },
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 24 },
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 60 },
								{ "s": [0], "t": 114 }
							]
						}
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.13, -0.15],
										[-0.11, -0.13],
										[-0.2, -0.16],
										[-0.21, 0.11],
										[0.09, 0.51],
										[0.13, 0.36],
										[0.1, 0.2],
										[0.13, 0.21],
										[2.61, 1.84],
										[3.91, 0.53],
										[1.54, -0.32],
										[0.35, -0.12],
										[0.33, -0.1],
										[0.56, -0.24],
										[2.13, -2.04],
										[0.45, -0.49],
										[0.41, -0.58],
										[0.69, -1.34],
										[0.49, -1.45],
										[0.25, -1.45],
										[-0.28, -2.31],
										[-0.36, -0.97],
										[-0.12, -0.28],
										[0, 0],
										[-1.91, -1.95],
										[-1.39, -0.87],
										[-1.74, -0.61],
										[-4.1, 0.52],
										[-1.94, 0.69],
										[-0.48, 0.18],
										[-0.46, 0.24],
										[-0.46, 0.23],
										[-0.45, 0.26],
										[-1.48, 1.85],
										[-0.74, 1.7],
										[-0.17, 1.84],
										[0.23, 1.92],
										[0.53, 1.67],
										[2.25, 2.39],
										[0.27, 0.2],
										[0.23, 0.08],
										[0.13, -0.16],
										[-0.21, -0.38],
										[-0.16, -0.26],
										[-0.23, -0.33],
										[-0.83, -3.1],
										[-0.16, -1.76],
										[0.18, -1.97],
										[1.23, -2.8],
										[1.14, -1.46],
										[1.78, -1.27],
										[1.26, -0.69],
										[0.74, -0.34],
										[0.78, -0.23],
										[1.63, -0.14],
										[0.81, -0.01],
										[0.77, 0.12],
										[1.32, 0.49],
										[1.25, 1.13],
										[0.24, 0.22],
										[0.15, 0.17],
										[0.07, 0.09],
										[0, 0],
										[0.1, 0.13],
										[0.19, 0.27],
										[0.24, 0.41],
										[0.24, 0.55],
										[0, 3.7],
										[-0.4, 1.9],
										[-0.78, 1.69],
										[-0.99, 1.3],
										[-0.96, 0.83],
										[-1.29, 0.59],
										[-0.3, 0.12],
										[-0.29, 0.09],
										[-0.27, 0.07],
										[-0.26, 0.05],
										[-1.11, -0.16],
										[-2.39, -1.52],
										[-1.56, -2.06],
										[0, 0]
									],
									"o": [
										[0.14, 0.18],
										[0.13, 0.16],
										[0.23, 0.26],
										[0.39, 0.31],
										[0.21, -0.1],
										[-0.04, -0.26],
										[-0.07, -0.17],
										[-0.1, -0.19],
										[-1.5, -2.41],
										[-2.61, -1.82],
										[-2.21, -0.26],
										[-0.38, 0.08],
										[-0.35, 0.11],
										[-0.66, 0.17],
										[-2.17, 1.08],
										[-0.45, 0.42],
										[-0.42, 0.52],
										[-0.84, 1.13],
										[-0.69, 1.34],
										[-0.5, 1.45],
										[-0.51, 2.92],
										[0.27, 2.32],
										[0.11, 0.29],
										[0, 0],
										[0.51, 0.98],
										[0.96, 0.96],
										[1.39, 0.87],
										[3.48, 1.24],
										[2.05, -0.25],
										[0.49, -0.14],
										[0.47, -0.21],
										[0.46, -0.23],
										[0.47, -0.22],
										[2.46, -1.52],
										[1.49, -1.85],
										[1.41, -3.44],
										[0.2, -2.18],
										[-0.23, -1.92],
										[-1.07, -3.33],
										[-0.29, -0.34],
										[-0.27, -0.2],
										[-0.45, -0.16],
										[-0.12, 0.16],
										[0.1, 0.19],
										[0.16, 0.26],
										[1.75, 2.29],
										[0.41, 1.55],
										[0.16, 1.76],
										[-0.14, 1.52],
										[-0.63, 1.39],
										[-1.15, 1.46],
										[-1.14, 0.85],
										[-0.69, 0.36],
										[-0.76, 0.27],
										[-1.56, 0.49],
										[-0.81, 0.08],
										[-0.8, -0.05],
										[-1.54, -0.22],
										[-2.63, -0.96],
										[-0.31, -0.29],
										[-0.22, -0.25],
										[-0.15, -0.17],
										[-0.07, -0.09],
										[0, 0],
										[-0.1, -0.14],
										[-0.18, -0.28],
										[-0.23, -0.41],
										[-1.1, -2.12],
										[0, -1.84],
										[0.4, -1.88],
										[0.78, -1.69],
										[0.99, -1.31],
										[1.44, -1.24],
										[0.33, -0.13],
										[0.29, -0.14],
										[0.3, -0.08],
										[0.28, -0.04],
										[2.09, -0.3],
										[3.39, 0.44],
										[2.4, 1.54],
										[0, 0],
										[0, 0]
									],
									"v": [
										[37.9, 11.63],
										[38.32, 12.13],
										[38.67, 12.57],
										[39.3, 13.2],
										[40.23, 13.51],
										[40.44, 12.58],
										[40.18, 11.65],
										[39.94, 11.08],
										[39.58, 10.48],
										[33.44, 4.02],
										[23.71, 0.15],
										[18.11, 0.3],
										[17, 0.54],
										[15.99, 0.85],
										[14.2, 1.59],
										[8.24, 5.92],
										[6.91, 7.33],
										[5.62, 8.95],
										[3.3, 12.68],
										[1.51, 16.9],
										[0.42, 21.31],
										[0.19, 29.38],
										[1.41, 34.47],
										[1.75, 35.34],
										[2.16, 36.18],
										[5.61, 40.94],
										[9.13, 43.77],
										[13.85, 46.05],
										[25.56, 47.24],
										[31.6, 45.8],
										[33.05, 45.25],
										[34.48, 44.64],
										[35.86, 43.95],
										[37.2, 43.18],
										[43.11, 37.98],
										[46.37, 32.56],
										[48.33, 24.55],
										[48.23, 18.4],
										[47.07, 13.01],
										[42.25, 4.35],
										[41.36, 3.57],
										[40.59, 3.16],
										[39.73, 3.2],
										[39.86, 4.04],
										[40.27, 4.69],
										[40.89, 5.53],
										[44.64, 13.71],
										[45.52, 18.69],
										[45.54, 24.29],
										[43.74, 30.99],
										[41.14, 35.34],
										[36.75, 39.5],
										[33.1, 41.75],
										[30.94, 42.76],
										[28.63, 43.57],
										[23.79, 44.49],
										[21.35, 44.57],
										[18.98, 44.36],
										[14.65, 43.31],
										[8.73, 39.86],
										[7.9, 39.08],
										[7.33, 38.46],
										[6.99, 38.06],
										[6.88, 37.92],
										[6.71, 37.71],
										[6.24, 37.1],
										[5.57, 36.08],
										[4.79, 34.66],
										[2.78, 25.55],
										[3.38, 19.88],
										[5.21, 14.45],
										[7.94, 9.91],
										[10.95, 6.7],
										[15.12, 3.98],
										[16.06, 3.59],
										[16.97, 3.31],
										[17.82, 3.08],
										[18.63, 2.95],
										[23.33, 2.92],
										[32, 6.16],
										[37.91, 11.61],
										[37.9, 11.63]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Vector 0",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [7.59, 6.96] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [23.39, 25.24] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": {
							"a": 1,
							"k": [
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 0 },
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [0], "t": 6 },
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 24 },
								{ "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.35, "y": 1 }, "s": [100], "t": 60 },
								{ "s": [0], "t": 114 }
							]
						}
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-0.3, -0.44],
										[-0.69, -0.69],
										[-0.27, -0.16],
										[0, 0],
										[0, 0],
										[0, 0],
										[-0.09, -0.1],
										[-0.2, -0.29],
										[-0.55, -0.86],
										[-0.5, 0.69],
										[-0.23, 0.29],
										[-0.06, 0.06],
										[-0.03, 0.04],
										[-0.04, 0.07],
										[-1.54, 1.52],
										[-0.35, 0.34],
										[-0.45, 0.79],
										[0.49, -0.18],
										[0.9, -0.85],
										[1.02, -1.01],
										[0.1, -0.22],
										[0.51, -0.73],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.08, -0.1],
										[0.09, 0.11],
										[0.05, 0.05],
										[0.12, 0.13],
										[0.13, 0.13],
										[0.8, 0.29],
										[0, 0]
									],
									"o": [
										[-0.57, -0.21],
										[0.43, 0.64],
										[0.42, 0.36],
										[0, 0],
										[0, 0],
										[0, 0],
										[0.1, 0.08],
										[0.19, 0.19],
										[0.4, 0.54],
										[0.57, -0.77],
										[0.27, -0.38],
										[0.14, -0.18],
										[0.05, -0.05],
										[0.06, -0.05],
										[0.25, -0.51],
										[1.01, -1.13],
										[0.82, -0.81],
										[0.25, -0.43],
										[-0.89, 0.33],
										[-0.35, 0.33],
										[-0.16, 0.16],
										[-0.45, 0.92],
										[-0.51, 0.72],
										[0, 0],
										[0, 0],
										[-0.09, 0.13],
										[-0.08, -0.12],
										[-0.06, -0.07],
										[-0.16, -0.17],
										[-0.24, -0.25],
										[-0.81, -0.78],
										[0, 0],
										[0, 0]
									],
									"v": [
										[1.28, 6.36],
										[0.06, 7.97],
										[1.68, 9.89],
										[2.69, 10.6],
										[2.74, 10.63],
										[2.81, 10.69],
										[2.97, 10.82],
										[3.26, 11.09],
										[3.84, 11.78],
										[5.28, 13.92],
										[6.95, 11.64],
										[7.74, 10.63],
										[7.97, 10.37],
										[8.1, 10.24],
										[8.24, 10.05],
										[11.28, 5.84],
										[13.32, 3.71],
										[15.13, 1.41],
										[13.98, 0.02],
										[11.37, 1.69],
										[9, 3.46],
										[8.59, 4.03],
										[6.99, 6.63],
										[6.08, 7.86],
										[5.55, 8.64],
										[5.3, 9.02],
										[5.04, 9.42],
										[4.78, 9.08],
										[4.61, 8.89],
										[4.19, 8.44],
										[3.64, 7.88],
										[1.27, 6.35],
										[1.28, 6.36]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0627, 0.0706, 0.0784] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2
				},
				{
					"ty": 4,
					"nm": "Gestural Line/symbol check 2 Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Gestural Line/symbol check 2 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [23.88, 23] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [23.88, 23] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -0.01],
										[0, 0],
										[0.01, 0],
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0.01],
										[0, 0],
										[-0.01, 0],
										[0, 0],
										[0, -0.01],
										[0, 0],
										[0.01, 0]
									],
									"v": [
										[47.77, 0.01],
										[47.77, 45.99],
										[47.76, 46],
										[0.01, 46],
										[0, 45.99],
										[0, 0.01],
										[0.01, 0],
										[47.76, 0]
									]
								}
							}
						}
					],
					"ind": 3
				}
			]
		},
		{
			"nm": "[Asset] Loom",
			"id": "10",
			"fr": 30,
			"layers": [
				{
					"ty": 4,
					"nm": "Vector",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Vector 9",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [46, 46] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [46, 46] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[-12.7, 0],
										[0, 0],
										[0, -12.7],
										[0, 0],
										[12.7, 0],
										[0, 0],
										[0, 12.7],
										[0, 0]
									],
									"o": [
										[0, -12.7],
										[0, 0],
										[12.7, 0],
										[0, 0],
										[0, 12.7],
										[0, 0],
										[-12.7, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 23],
										[23, 0],
										[69, 0],
										[92, 23],
										[92, 69],
										[69, 92],
										[23, 92],
										[0, 69],
										[0, 23]
									]
								}
							}
						},
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[73.15, 42.98],
										[57.27, 42.98],
										[71.03, 35.04],
										[68.01, 29.81],
										[54.25, 37.75],
										[62.19, 24],
										[56.96, 20.97],
										[49.02, 34.73],
										[49.02, 18.85],
										[42.98, 18.85],
										[42.98, 34.73],
										[35.04, 20.97],
										[29.81, 23.99],
										[37.75, 37.75],
										[23.99, 29.81],
										[20.97, 35.04],
										[34.73, 42.98],
										[18.85, 42.98],
										[18.85, 49.02],
										[34.73, 49.02],
										[20.97, 56.96],
										[23.99, 62.19],
										[37.75, 54.25],
										[29.81, 68.01],
										[35.04, 71.03],
										[42.98, 57.27],
										[42.98, 73.15],
										[49.02, 73.15],
										[49.02, 57.27],
										[56.96, 71.03],
										[62.19, 68.01],
										[54.25, 54.25],
										[68, 62.19],
										[71.02, 56.96],
										[57.27, 49.02],
										[73.15, 49.02],
										[73.15, 42.98]
									]
								}
							}
						},
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 4.56],
										[-4.55, 0],
										[0, -4.55],
										[4.55, 0]
									],
									"o": [
										[-4.55, 0],
										[0, -4.55],
										[4.55, 0],
										[0, 4.56],
										[0, 0]
									],
									"v": [
										[46, 54.22],
										[37.75, 45.97],
										[46, 37.72],
										[54.25, 45.97],
										[46, 54.22]
									]
								}
							}
						}
					],
					"ind": 1
				},
				{
					"ty": 4,
					"nm": "Loom Bg",
					"sr": 1,
					"st": 0,
					"op": 241,
					"ip": 0,
					"hd": false,
					"ln": "Loom 0-bg",
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": { "a": 0, "k": [46, 46] },
						"s": { "a": 0, "k": [100, 100] },
						"sk": { "a": 0, "k": 0 },
						"p": { "a": 0, "k": [46, 46] },
						"r": { "a": 0, "k": 0 },
						"sa": { "a": 0, "k": 0 },
						"o": { "a": 0, "k": 100 }
					},
					"ef": [],
					"shapes": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"nm": "",
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, -8.97],
										[0, 0],
										[8.97, 0],
										[0, 0],
										[0, 8.97],
										[0, 0],
										[-8.97, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 8.97],
										[0, 0],
										[-8.97, 0],
										[0, 0],
										[0, -8.97],
										[0, 0],
										[8.97, 0]
									],
									"v": [
										[92, 16.25],
										[92, 75.75],
										[75.75, 92],
										[16.25, 92],
										[0, 75.75],
										[0, 16.25],
										[16.25, 0],
										[75.75, 0]
									]
								}
							}
						},
						{
							"ty": "fl",
							"bm": 0,
							"hd": false,
							"nm": "",
							"c": { "a": 0, "k": [0.0941, 0.4078, 0.8588] },
							"r": 1,
							"o": { "a": 0, "k": 100 }
						}
					],
					"ind": 2
				}
			]
		}
	]
}
